import { arrayToObj } from "@/lib/utilities/index";

export let NotificationType = {
  MessageResponse: 1, //supported
  Article: 2,
  Gaming: 3,
  Gaming_leaderChange: 4,
  PendingUser: 5,
  ApprovedUser: 6,
  DeviceTokenCheck: 9,
  WorkflowMessageActionStatus: 10,
  GroupResponse: 11, //supported
  GroupCreatedResponse: 12, //supported
  GroupUpdatedResponse: 13, //supported
  GroupDeletedResponse: 14, //supported
  GroupAddUserResponse: 15, //supported
  GroupRemoveUserResponse: 16, //supported
  GroupFavoriteResponse: 17, //supported
  SystemResponse: 18,
  AccountUserResponse: 19, //supported
  UserResponse: 20, //supported
  SystemWideResponse: 21,
  SystemWideUnavailable: 22,
  SystemWideLogout: 23,
  UserNotification: 24, //supported
  StoreNotification: 25,
  GroupMessageResponse: 26, //supported
  ViewStoreUpdate: 27, //supported
  FavoriteUserResponse: 29, //supported
  CalendarEvent: 34,
  CalendarEventStatus: 35,
  CalendarEventReminder: 36,
  UserGroupInfoMessage: 111,
  GroupCreatedMessage: 112,
  GroupUpdatedMessage: 113,
  GroupDeletedMessage: 114,
  GroupAddUserMessage: 115,
  GroupRemoveUserMessage: 116,
  GroupFavoriteMessage: 117,
  AccountUserInfoMessage: 119,
  UserInfoMessage: 120,
  GroupMessageMessage: 126,
  UserFavoriteMessage: 129,
  GroupSettingMessage: 133,
  ApiResponseMessage: 134,
  UserCustomNotification: 135
};

export let StatesProvinces = [
  {
    Name: "Alabama",
    Id: 1
  },
  {
    Name: "Alaska",
    Id: 2
  },
  {
    Name: "Arizona",
    Id: 3
  },
  {
    Name: "Arkansas",
    Id: 4
  },
  {
    Name: "California",
    Id: 5
  },
  {
    Name: "Colorado",
    Id: 6
  },
  {
    Name: "Connecticut",
    Id: 7
  },
  {
    Name: "Delaware",
    Id: 8
  },
  {
    Name: "Florida",
    Id: 9
  },
  {
    Name: "Georgia",
    Id: 10
  },
  {
    Name: "Hawaii",
    Id: 11
  },
  {
    Name: "Idaho",
    Id: 12
  },
  {
    Name: "Illinois",
    Id: 13
  },
  {
    Name: "Indiana",
    Id: 14
  },
  {
    Name: "Iowa",
    Id: 15
  },
  {
    Name: "Kansas",
    Id: 16
  },
  {
    Name: "Kentucky",
    Id: 17
  },
  {
    Name: "Louisiana",
    Id: 18
  },
  {
    Name: "Maine",
    Id: 19
  },
  {
    Name: "Maryland",
    Id: 20
  },
  {
    Name: "Massachusetts",
    Id: 21
  },
  {
    Name: "Michigan",
    Id: 22
  },
  {
    Name: "Minnesota",
    Id: 23
  },
  {
    Name: "Mississippi",
    Id: 24
  },
  {
    Name: "Missouri",
    Id: 25
  },
  {
    Name: "Montana",
    Id: 26
  },
  {
    Name: "Nebraska",
    Id: 27
  },
  {
    Name: "Nevada",
    Id: 28
  },
  {
    Name: "New Hampshire",
    Id: 29
  },
  {
    Name: "New Jersey",
    Id: 30
  },
  {
    Name: "New Mexico",
    Id: 31
  },
  {
    Name: "New York",
    Id: 32
  },
  {
    Name: "North Carolina",
    Id: 33
  },
  {
    Name: "North Dakota",
    Id: 34
  },
  {
    Name: "Ohio",
    Id: 35
  },
  {
    Name: "Oklahoma",
    Id: 36
  },
  {
    Name: "Oregon",
    Id: 37
  },
  {
    Name: "Pennsylvania",
    Id: 38
  },
  {
    Name: "Rhode Island",
    Id: 39
  },
  {
    Name: "South Carolina",
    Id: 40
  },
  {
    Name: "South Dakota",
    Id: 41
  },
  {
    Name: "Tennessee",
    Id: 42
  },
  {
    Name: "Texas",
    Id: 43
  },
  {
    Name: "Utah",
    Id: 44
  },
  {
    Name: "Vermont",
    Id: 45
  },
  {
    Name: "Virginia",
    Id: 46
  },
  {
    Name: "Washington",
    Id: 47
  },
  {
    Name: "West Virginia",
    Id: 48
  },
  {
    Name: "Wisconsin",
    Id: 49
  },
  {
    Name: "Wyoming",
    Id: 50
  }
];

export const CountryCodes = {
  USA: 1,
  Canada: 2
};

export const CountryOptions = [
  {
    id: 1,
    abbr: "US",
    code: "1",
    flag: "/static/assets/img/us-flag.svg"
  },
  {
    id: 2,
    abbr: "CA",
    code: "1",
    flag: "/static/assets/img/canada-flag.svg"
  },
  {
    id: 3,
    abbr: "GB",
    code: "44",
    flag: "/static/assets/img/gb-flag.svg"
  },
  {
    id: 4,
    abbr: "FR",
    code: "333",
    flag: "/static/assets/img/fr-flag.svg"
  }
];

export let delayTypes = [
  {
    id: 0,
    name: "Immediately"
  },
  {
    id: 1,
    name: "Before"
  },
  {
    id: 2,
    name: "After"
  }
];

export let delayTypesName = {
  Immediately: 0,
  Before: 1,
  After: 2
};

export let delayUnits = [
  {
    id: 1,
    name: "Minutes"
  },
  {
    id: 2,
    name: "Hours"
  },
  {
    id: 3,
    name: "Days"
  },
  {
    id: 4,
    name: "Weeks"
  },
  {
    id: 5,
    name: "Months"
  },
  {
    id: 6,
    name: "Years"
  }
];
export const DelayUnitsEnum = {
  Minutes: 1,
  Hours: 2,
  Days: 3,
  Weeks: 4,
  Months: 5,
  Years: 6
};

export let ContactRelationshipTypes = [
  {
    Name: "Parent",
    Id: 1
  },
  {
    Name: "Child",
    Id: 2
  },
  {
    Name: "Spouse",
    Id: 3
  },
  {
    Name: "Sibling",
    Id: 4
  },
  {
    Name: "Grandparent",
    Id: 5
  },
  {
    Name: "Grandchild",
    Id: 6
  },
  {
    Name: "Partner",
    Id: 7
  },
  {
    Name: "Other",
    Id: 8
  },
  {
    Name: "Possible Duplicate",
    Id: 9
  }
];

export let ChannelType = {
  Unknown: 0,
  Control: 5,
  Direct: 10,
  Group: 20,
  Request: 30
};

export let StepInstanceStatus = {
  NotSet: 0,
  New: 10,
  Ready: 50,
  InProgress: 100,
  Overdue: 150,
  Paused: 500,
  Cancelled: 900,
  Success: 1000,
  CanClaimStep: 246,
  CanCompleteStep: 246
};

export let GroupType = {
  Unknown: 0,
  SystemAccount: 1, //Channels (Groups)
  SystemStore: 2, //Channels (Groups)
  AdHoc: 3, //Channels (Groups)
  Team: 4, //Channels (Groups)
  DirectMessage: 5, //Messages
  CrmCustomer: 6, //Channels (Groups)
  Request: 7, //Processes
  CustomAccount: 8, //Channels (Groups)
  CustomStore: 9, //Channels (Groups)
  HR: 10,
  Subscriptions: 11,
  CalendarEvent: 12
};

export let GroupMessagingType = {
  None: 0,
  Broadcast: 10,
  Interactive: 20
};

export let MessageType = {
  Unknown: 0,
  User: 10,
  System: 20
};

export let WorkflowStepAction = {
  NotSet: 0,
  DeclineRequest: 5,
  Claim: 10,
  Complete: 20,
  TakeSurvey: 30,
  TakeForm: 40,
  CompleteYes: 50,
  CompleteNo: 60,
  Assign: 70,
  Reassign: 80
};

export let WorkflowStepType = {
  NotSet: 0,
  Task: 10,
  Form: 20,
  Survey: 30,
  File: 40,
  Condition: 50,
  Integration: 60
};

export let PayloadType = {
  Error: 999999,
  NotSet: 0,
  Url: 1,
  Inventory: 2,
  Customer: 3,
  AutoAlertNotification: 4,
  Giphy: 5,
  Form: 6,
  Json: 7,
  AddUser: 8,
  RemoveUser: 9,
  Image: 10,
  File: 11,
  MarkDown: 12
};

export let CoreUserStatus = {
  Active: 1,
  Inactive: 2,
  Pending: 3
};

export let UserAvailability = {
  Available: 10,
  Busy: 20,
  // "Not Available": 100,
  NotAvailable: 100
};

export let DataMiningAlertBlock = {
  NONE: 0x00000000,
  A: 0x00000001, // Alert
  F: 0x00000002, // Flex Alert
  S: 0x00000004, // Service Alert
  P: 0x00000008, // Service Appointment
  M: 0x00000010, // Mileage Alert
  W: 0x00000020, // Warranty Alert
  C: 0x00000040, // Contract End Alert
  I: 0x00000080, // In-Market Alert
  E: 0x00000100 // In-Market Engaged Alert
};

export let FeatureFlags = {
  Calendar: 1, //fuzecast
  Reviews: 2, //fuzecast
  Comparisons: 4, //fuzecast
  Articles: 8, //fuzecast
  Messages: 16, //fuzecast
  Pando: 32, //fuzecast
  ProfileFuze: 64, //fuzecast
  Gamification: 128, //fuzecast
  Reports: 256, //fuzecast
  PandoLite: 512 //fuzecast
};

export const Permissions = {
  NotSet: 0,
  ManagerDashboard: 1,
  BDCDashboard: 2,
  SalesDashboard: 3,
  RulesAdministration: 4,
  RulesViewOnly: 5,
  Opportunities: 6,
  PriorityOpportunities: 7,
  OpportunitiesSearch: 8,
  ServiceExperience: 9,
  UnmatchedDMSSales: 10,
  ManageCallTracking: 11,
  SLMDashboardManager: 12,
  OperatorPanelAdmin: 13,
  WishlistManager: 14
};

export let InboxFilterCategory = {
  Inbox: "Inbox",
  UnreadMessages: "Inbox: Unread Messages",
  New: "Inbox: New",
  InProgress: "Inbox: In Progress",
  Overdue: "Inbox: Overdue",
  Favorites: "Favorites",
  Messages: "Messages",
  //Channels: 'Channels', // NOTE: changed to "Groups"
  Groups: "Groups",
  Processes: "Processes",
  Tasks: "Tasks"
};
// SupportedFileUploadFormats: ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "tif", "csv", "pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt", "rtf"],

export let SupportedFilePreviewFormats = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "svg",
  "jfif",
  "txt"
];

export let SupportedVideoFormats = ["mp4", "mov", "ogg", "webm", "ogv"];

export let SupportedAudioFormats = ["mp3", "wav"];

export let FileFormatIcons = [
  "csv",
  "doc",
  "docx",
  "eml",
  "form",
  "html",
  "pdf",
  "ppt",
  "pptx",
  "rtf",
  "tif",
  "tiff",
  "txt",
  "xls",
  "xlsx"
];

export let Colors = [
  "304976",
  "6CBE6A",
  "68A4D6",
  "68CCE4",
  "95989A",
  "9088BF",
  "E94D68",
  "EE8761",
  "F8BE6B"
];

export let DefaultAvatars = {
  PandoBot: "static/assets/img/pando_bot_avatar.png",
  Channel: "static/assets/img/channel_avatar.png"
};

export let WorkflowInstanceStatus = {
  NotSet: 0,
  New: 10,
  InProgress: 100,
  Overdue: 150,
  Cancelled: 900,
  AutoCancelled: 901,
  Success: 1000
  // CanClaim: New | InProgress | Overdue,
  // CanComplete: InProgress | Overdue
};

export let FormInputTypes = [
  {
    Name: "SectionHeader",
    Id: 0
  },
  {
    Name: "Boolean",
    Id: 1
  },
  {
    Name: "ShortAnswer",
    Id: 2
  },
  {
    Name: "LongAnswer",
    Id: 3
  },
  {
    Name: "SingleSelectDropDown",
    Id: 4
  },
  {
    Name: "MultiSelection",
    Id: 5
  },
  {
    Name: "Date",
    Id: 6
  },
  {
    Name: "Time",
    Id: 7
  },
  {
    Name: "SingleSelectRadio",
    Id: 8
  },
  {
    Name: "LinearScale",
    Id: 9
  },
  {
    Name: "ShortName",
    Id: 10
  },
  {
    Name: "FullName",
    Id: 11
  },
  {
    Name: "Address",
    Id: 12
  }
];

export let WorkflowContext = {
  NotSpecified: 0,
  Customer: 10,
  Inventory: 20,
  Executive: 30
};

export let FormTakerMode = {
  StepInstanceForm: 0,
  StartProcessForm: 1
};

export let HtmlEscapeCodes = [
  {
    Symbol: /&/g,
    EscapeCode: "&amp;"
  },
  {
    Symbol: /"/g,
    EscapeCode: "&quot;"
  },
  {
    Symbol: /'/g,
    EscapeCode: "&#039;"
  },
  {
    Symbol: /</g,
    EscapeCode: "&lt;"
  },
  {
    Symbol: />/g,
    EscapeCode: "&gt;"
  }
];

export let DayOfWeek = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6
};

export let KeyCodes = {
  Enter: 13,
  UpArrow: 38,
  DownArrow: 40
};

export let Mentions = {
  NotSet: 0,
  User: 1,
  Channel: 2,
  Reserved: 3
};

export let NotifyLevel = {
  All: 1,
  MentionsOnly: 2,
  None: 3
};

export let UserWorkScheduleType = {
  NotScheduled: 1,
  Scheduled: 10,
  TimeOff: 20,
  Sick: 30,
  Training: 40,
  Other: 100
};

export const NavMenuCategory = {
  NotSet: 0,
  ManagerDashboard: 1,
  BDCDashboard: 2,
  SalesDashboard: 3,
  Reporting: 4,
  RulesAdministration: 5,
  ContactSearch: 6,
  DeliveryDashboard: 7,
  ShowroomDashboard: 8,
  LeadsDashboard: 9,
  Opportunities: 10,
  PriorityOpportunities: 11,
  OpportunitiesSearch: 12,
  ServiceExperience: 13,
  UnmatchedDMSSales: 14,
  CallTrackingDashboard: 15,
  SLM: 16,
  Reports: 17,
  InventoryWishlist: 18,
  Inventory: 19,
  DataMining: 20,
  CXMLogs: 21,
  Dashboards: 22
};

export const NavMenuSubcategory = {
  NotSet: 0,
  UserActivity: 1,
  SLMDashboard: 2,
  OperatorsPanel: 3,
  ContactSearch: 4,
  OpportunitiesSearch: 5,
  OpportunitiesDashboard: 6,
  PriorityOpportunities: 7,
  ServiceExperience: 8,
  InventorySearch: 9,
  InventoryWishlist: 10,
  LeadsDashboard: 11,
  ShowroomDashboard: 12,
  DeliveryDashboard: 13,
  CallTrackingDashboard: 14,
  ManagerDashboard: 15,
  BDCDashboard: 16,
  SalesDashboard: 17,
  Reports: 18,
  RulesAdministration: 19,
  UnmatchedDMSSales: 20
};

export let ProfileTabsEnum = {
  Snapshot: 0,
  Profile: 1,
  Garage: 2,
  Leads: 3,
  Service: 5,
  Messages: 6,
  Activity: 7,
  Resolution: 9
};
export let ProfileTabsActionIdEnum = {
  Snapshot: 147,
  Profile: 198,
  Garage: 236,
  ActiveServiceLeads: 229, //sales and service were backwards
  ActiveSalesLeads: 228,
  LeadsHistory: 230,
  Service: 227,
  Messages: 231,
  Activity: 235,
  Engagement: 232,
  Resolution: 233,
  Changelog: 234
};
export let RightNavMode = {
  NotSet: 0,
  Normal: 1, // Pushes the panels left for display
  Overlay: 2, // Displays on top of the panels with a fixed width (500px)
  ExtendedOverlay: 3, // Displays on top of the panels with a variable width (65%)
  PanelOverlay: 4, // Displays on top of the second panel
  FullOverlay: 5 // Displays on top of the panel container
};

export let RightNavContentType = {
  NotSet: 0,
  Calls: 1,
  Engaged: 2,
  Emails: 3,
  Appointments: 4,
  SLM: 5,
  RecentActivities: 6,
  TeamMember: 7,
  Dealsheet: 8,
  CustomerDashboard: 9,
  ShowroomActivity: 10,
  ShowroomAppointments: 11,
  DeliveryActivity: 12,
  DeliveryAppointments: 13,
  ShowroomDeliveryActionsPanel: 14,
  AddProspect: 15,
  LeadActivity: 16,
  SendBulkEmail: 17,
  ReassignTasks: 18,
  MatchDMSSale: 19,
  AddCallTrackingProspect: 20,
  AssignUnmatchedCall: 21,
  LogCallAfterMatchingSlideout: 22,
  CustomerMerge: 23,
  UnreadSettings: 24,
  ShowroomInShowroom: 25,
  LeadsSendBulkEmail: 26,
  AdditionalLeads: 27,
  TeamMemberAppt: 28,
  SendBulkAutoAssist: 29,
  LeadsSendBulkAutoAssist: 30,
  WishlistVehicleCounts: 31,
  LeadsBulkReassign: 32,
  SLMProcessComplete: 33,
  CustomersViewed: 34,
  InventoryFeaturesAndOpps: 35,
  InventoryRecallDetails: 36,
  InventoryLeadDetails: 37,
  InventorySendBulkEmail: 38,
  FindBuyerOpportunities: 39,
  Video: 40,
  CustomerTagDetails: 41
};

export let RecentActivityType = {
  //All: null,
  SMS: 4,
  O2O: 1,
  SLM: 7,
  Email: 2,
  Phone: 3,
  Reviews: 8,
  Website: 5,
  GeoAlert: 9,
  AutoAssist: 10
};

export let ChangeLogType = {
  None: 0,
  Access: 1,
  Activity: 2,
  Contact: 3,
  Opportunity: 4
};

export let AlertType = {
  FlexAlert: 1,
  ConversionAlert: 2,
  ContractEnd: 3,
  MileageAlert: 4,
  WarrantyAlert: 5,
  Service: 6,
  ServiceAppointment: 7,
  InMarket: 8,
  InMarketEngaged: 9
};

export let InventoryAlertTypes = {
  Alert: 100,
  Flex: 200,
  Conversion: 300,
  InMarket: 400,
  InMarketEngaged: 500,
  ContractEnd: 600,
  Service: 700,
  Appointment: 800,
  Mileage: 900,
  Warranty: 1000
};

export let OpportunitiesTabsEnum = {
  All: 0,
  Overdue: 1,
  InProgress: 2,
  New: 3,
  Completed: 4,
  Cancelled: 5
};
export let WorkplanActivityTabsEnum = {
  All: 0,
  Calls: 1,
  EmailSent: 2,
  TextOut: 3,
  Notes: 4,
  ApptSch: 5,
  ApptShown: 6
};

export let TransmissionType = {
  Manual: 21,
  Automatic: 22,
  CVT: 23
};

export let ParentFilterType = {
  Customer: 9,
  ReplacementVehicle: 10,
  CurrentVehicle: 11,
  RepairOrderOpCode: 12,
  DealData: 34,
  ServiceData: 35,
  Lead: 67,
  AutoAssistantAI: 73,
  Tags: 74
};

export let ChildFilter = {
  OpCode: 24,
  CustomerType: 34,
  AlertType: 35,
  DealDate: 43,
  TransmissionType: 44,
  CurrentBankName: 49,
  LastRODate: 50,
  ServiceAdvisorID: 57,
  ServiceAdvisorName: 58,
  Tag: 59,
  CurrentVehicleInfo: 67,
  ReplacementVehicleInfo: 68,
  LeadType: 100,
  LeadStatus: 101,
  LeadSource: 102,
  LeadAge: 103,
  VehicleOfInterest: 105,
  Stock: 106,
  TradeInVehicle: 107,
  LeadCategory: 108,
  TimeSinceRODate: 122,
  TimeSinceDealEnd: 123,
  LeadDisposition: 127,
  AlertAndType: 128,
  DealType: 134,
  WishlistGroup: 135,
  UnwindReasons: 136,
  Survey: 137,
  StockBeginsWith: 138,
  StockEndsWith: 139,
  AIConversationCategory: 141,
  AIConversation: 142,
  TagsTagType: 143,
  TagsTagName: 144,
  TimeSinceRODateMoreThan: 145
};

export let SubFiltersWithPlaceholder = {
  DistanceFromDealer: 13,
  PaymentDifferenceLessThan: 39,
  PaymentDifferenceGreaterThan: 40,
  DealTermGreaterThan: 45,
  DealTermLessThan: 46,
  DealRateLessThan: 47,
  DealRateGreaterThan: 48
};

export const RuleStatus = {
  New: 1,
  InProgress: 2,
  Completed: 3,
  Canceled: 4,
  OnHold: 5,
  ManagerComplete: 6
};

export const TaskStatus = {
  Pending: 1,
  InProgress: 2,
  Overdue: 3,
  Completed: 4,
  Cancelled: 5,
  BulkCompleted: 6,
  OnHold: 7,
  Suppressed: 8,
  Future: 9,
  NotGenerated: 10
};

export const TaskType = {
  DirectCall: 1,
  DirectEmail: 2,
  DirectSMS: 3,
  OneToOneEmail: 4,
  OneToOneMail: 5,
  AutomatedEmail: 6,
  PreApptPhoneCall: 7,
  PreApptAutoEmail: 8,
  ReviewAccount: 9,
  LeadAssignment: 10,
  ContactCustomer: 11,
  Process: 12,
  SendToAutoAssistant: 13,
  SendToCRM: 14
};

export const AutoAssistantConversationType = {
  Leads: 1,
  Service: 2,
  Loyalty: 3
};

export let VehicleType = {
  New: 0,
  Used: 1,
  CPO: 2
};

export let DmsPushValidationStatus = {
  OK: 0,
  UserNotAuthorized: 1,
  DealerAccessVoilation: 2,
  DealerPushNotActive: 3,
  MissingData: 4
};

export let NoLongerOwnsTitle = {
  Owned: "Confirm - No Longer Owns ",
  NotOwned: "Confirm - Reset to Currently Owned "
};

export let NoLongerOwnsDescription = {
  Owned:
    "You are about to mark this vehicle no longer owns. This will stop all processes and tasks associated with the vehicle. Are you sure?",
  NotOwned: "You are about to reset this vehicle to owned. Are you sure?"
};

export let PushToDmsDescription = {
  IsReview:
    "Please review the data before pushing to the DMS.  If any changes are necessary, go back to the deal sheet to make those changes.",
  IsReviewV2:
    "Please review the data before pushing to the DMS.  If any changes are necessary, go back to the deal sheet to make those changes.  Any changes made here are reflected only in the DMS and not in the deal sheet.",
  IsReviewRouteOne:
    "Please review the data before pushing to the RouteOne.  If any changes are necessary, go back to the deal sheet to make those changes.",
  IsReviewDTFinance:
    "Please review the data before pushing to the DealerTrack Finance.  If any changes are necessary, go back to the deal sheet to make those changes.",
  IsReviewNoInventory:
    "To include deal data the replacement vehicle must be a specific inventory vehicle with an associated VIN number.",
  PushSuccessful: "The DMS record was successfully updated or added.",
  PushFailure:
    "The DMS deal record was not successfully updated or added, please try again another time.",
  MatchingRecords:
    " matching customer records were found in the DMS data.  Please select the desired DMS customer to update.  If you don't see the customer you are looking for, you can create a new record.",
  AddCustomerFailed: "Add Customer failed.",
  AddDealFailed: "Add Deal failed.",
  DealExistsFailed: "A Deal already exists for this customer. DMS Deal ID: ",
  ForceInsertFailed: "Force Insert of Customer failed.",
  GeneralFailed: "An unexpected error occurred.",
  UpdateCustomerFailed: "Update Customer failed.",
  UpdateDealFailed: "Update Deal failed.",
  CustomerIdMismatch:
    "Mapped CustomerID mismatch with CustomerID in the request.",
  DealMismatch: "Mapped DmsDealId mismatch with DealNumber in the request.",
  MissingSalesPersonId:
    "At least one Salesperson ID is required to push a deal for this dealer.",
  BadSalesPersonId: " is an invalid Salesperson ID.",
  BadStockNumber: "The Vehicle of Interest Stock Number was not found.",
  InventoryNotFound: "Could not find the inventory record for VIN: ",
  DealerbuiltError:
    "Error occurred while attempting to push to Dealerbuilt.  Please Try again later. "
};
export let PushToDmsErrorCodes = {
  ForceInsertFailed: "FRSINS",
  UpdateCustomerFailed: "UPDCST",
  AddCustomerFailed: "ADDCST",
  UpdateDealFailed: "UPDDEA",
  AddDealFailed: "ADDDEA",
  GeneralFailed: "GNFAIL",
  DealExistsFailed: "DEAXST",
  CustomerIdMismatch: "CSTMSM",
  DealMismatch: "DEAMSM",
  MissingSalesPersonId: "MSSPID",
  BadSalesPersonId: "BDSPID",
  BadStockNumber: "BDSTCK",
  InventoryNotFound: "INVNFD",
  DealerbuiltError: "DBERROR"
};
export let UserSettingKeys = {
  LAST_VIEWED_PAGE: "pando_cxm_last_viewed_page",
  GLOBAL_FRAME_HEADER_INFO: "global_frame_header_info",
  // Saved Searches
  CONTACT_SEARCH_SAVED_SEARCHES: "pando_cxm_contact_search_saved_searches",
  MANAGER_DASHBOARD_SAVED_SEARCHES:
    "pando_cxm_manager_dashboard_saved_searches",
  BDC_DASHBOARD_SAVED_SEARCHES: "pando_cxm_bdc_dashboard_saved_searches",
  SALES_DASHBOARD_SAVED_SEARCHES: "pando_cxm_sales_dashboard_saved_searches",
  LEADS_DASHBOARD_SAVED_SEARCHES: "pando_cxm_leads_dashboard_saved_searches",
  OPPORTUNITY_SEARCH_ADVANCED_SEARCH_SAVED_SEARCHES:
    "pando_cxm_opportunity_search_advanced_search_saved_searches",
  // Dashboard Layout
  MANAGER_DASHBOARD_LAYOUT: "pando_cxm_manager_dashboard_layout",
  BDC_DASHBOARD_LAYOUT: "pando_cxm_bdc_dashboard_layout",
  SALES_DASHBOARD_LAYOUT: "pando_cxm_sales_dashboard_layout",
  LEADS_DASHBOARD_LAYOUT: "pando_cxm_leads_dashboard_layout",
  // Opportunities Dashboard Layout
  OPPORTUNITIES_DASHBOARD_OPPORTUNITIES_BY_ALERT_LAYOUT:
    "pando_cxm_opportunities_dashboard_opportunities_by_alert_layout",
  OPPORTUNITIES_DASHBOARD_CAMPAIGN_SEARCHES_LAYOUT:
    "pando_cxm_opportunities_dashboard_campaign_searches_layout",
  OPPORTUNITIES_DASHBOARD_TAGGED_OPPORTUNITIES_LAYOUT:
    "pando_cxm_opportunities_dashboard_tagged_opportunities_layout",
  OPPORTUNITY_DASHBOARD_SEARCH_RESULTS:
    "pando_cxm_opportunity_dashboard_search_results",
  // Priority Opportunities Dashboard Layout
  PRIORITY_OPPORTUNITIES_FAVORITE_WIDGET:
    "pando_cxm_priority_opportunities_favorite_widget",
  PRIORITY_OPPORTUNITIES_SERVICE_LAYOUT:
    "pando_cxm_priority_opportunities_service_layout",
  PRIORITY_OPPORTUNITIES_CUSTOMER_MESSAGES_LAYOUT:
    "pando_cxm_priority_opportunities_customer_messages_layout",
  PRIORITY_OPPORTUNITIES_WEB_LAYOUT:
    "pando_cxm_priority_opportunities_web_layout",
  PRIORITY_OPPORTUNITIES_RECENTLY_ASSIGNED_LAYOUT:
    "pando_cxm_priority_opportunities_recently_assigned_layout",
  PRIORITY_OPPORTUNITIES_TOP_RETAIL_OPPORTUNITIES_LAYOUT:
    "pando_cxm_priority_opportunities_top_retail_opportunities_layout",
  PRIORITY_OPPORTUNITIES_TOP_LEASE_OPPORTUNITIES_LAYOUT:
    "pando_cxm_priority_opportunities_top_lease_layout",
  PRIORITY_OPPORTUNITIES_ONE_TO_ONE_LAYOUT:
    "pando_cxm_priority_opportunities_one_to_one_layout",
  PRIORITY_OPPORTUNITIES_REVIEW_PRO_LAYOUT:
    "pando_cxm_priority_opportunities_review_pro_layout",
  PRIORITY_OPPORTUNITIES_GEO_ALERT_LAYOUT:
    "pando_cxm_priority_opportunities_geo_alert_layout",
  // Service Experience Layout
  SERVICE_EXPERIENCE_SERVICE_MONITOR_LAYOUT:
    "pando_cxm_service_experience_service_monitor_layout",
  SERVICE_EXPERIENCE_HAVE_NOT_SERVICED_LAYOUT:
    "pando_cxm_service_experience_have_not_serviced_layout",
  SERVICE_EXPERIENCE_DUE_FOR_SERVICE_LAYOUT:
    "pando_cxm_service_experience_due_for_service_layout",
  SERVICE_EXPERIENCE_NEEDS_WARRANTY_LAYOUT:
    "pando_cxm_service_experience_needs_warranty_layout",
  SERVICE_EXPERIENCE_SERVICE_APPOINTMENTS_LAYOUT:
    "pando_cxm_service_experience_service_appointments_layout",
  // Others
  DELIVERY_LOG_SETTING: "pando_cxm_delivery_log_setting",
  SHOWROOM_LOG_SETTING: "pando_cxm_showroom_log_setting",
  REPORTS_SETTINGS: "pando_cxm_reports_settings",
  INVENTORY_SEARCH_RESULTS_LAYOUT: "pando_cxm_inventory_search_results_layout",
  INVENTORY_LEAD_DETAILS_LAYOUT: "pando_cxm_inventory_lead_details_layout",
  SALES_DASHBOARD_TASK_LIST_LAYOUT: "pando_cxm_sales_dashboard_task_list_layout"
};

export const DealerSettingsKey = {
  CalendarSettings: "CALENDAR_COLOR_SETTINGS"
};

// TODO: Rename this to Touchpoint (after renaming the other one below)
export let TouchpointType = {
  Showroom: 1,
  Delivery: 2
};

export let TouchpointList = [
  {
    Id: 1,
    Name: "Showroom",
    Slug: "showroom_visit"
  },
  {
    Id: 2,
    Name: "Delivery",
    Slug: "delivery"
  }
];

export let TouchpointInstanceStatus = {
  New: 0,
  Started: 1,
  Restarted: 2,
  Completed: 3,
  Canceled: 4
};
export let LeadTouchpointItemSlugs = {
  contactAttempted: "contact_attempted",
  contactMade: "contact_made",
  shopping: "shopping",
  tradeIn: "trade_in",
  waitingOnVehicle: "waiting_on_vehicle",
  demoScheduled: "demo_scheduled"
};
export let TouchpointInstanceStatusList = [
  {
    id: 0,
    name: "New"
  },
  {
    id: 1,
    name: "Started"
  },
  {
    id: 2,
    name: "Restarted"
  },
  {
    id: 3,
    name: "Completed"
  },
  {
    id: 4,
    name: "Canceled"
  }
];

export let TouchPointItemTypes = {
  demo: 1,
  tradeAppraisal: 2,
  writeUp: 3,
  managerTurnOver: 4,
  financeAndInsurance: 5,
  accessoriesIntro: 6,
  serviceIntro: 7,
  techIntro: 8,
  contactAttempted: 9,
  contactMade: 10,
  shopping: 11,
  tradeIn: 12,
  waitingOnVehicle: 13,
  demoScheduled: 14,
  visit: "all"
};

// TODO: fill delivery items

export let TouchPointItemInstance = {
  Demo: 1,
  TradeAppraisal: 2,
  WriteUp: 3,
  ManagerTurnOver: 4
};

export let TouchpointItemInstanceStatus = {
  New: 0,
  Started: 1,
  Completed: 2,
  Canceled: 3
};

export let TouchPointItemInstanceStatusList = [
  {
    id: 0,
    name: "New"
  },
  {
    id: 1,
    name: "Started"
  },
  {
    id: 2,
    name: "Completed"
  },
  {
    id: 3,
    name: "Canceled"
  }
];

export let LeadCategory = {
  Sales: 1,
  Service: 2,
  Parts: 3
};

export let LeadStatus = {
  Active: 1,
  Lost: 2,
  Bad: 3,
  Duplicate: 4,
  Sold: 5,
  SoldPending: 6,
  SoldDelivered: 5
};
export let IntegrationTypes = {
  Helms: 1,
  UniteDigital: 2
};
export let timeSelection = [
  {
    time: 0,
    name: "Immediately"
  },
  {
    time: 2,
    name: "2 Minutes"
  },
  {
    time: 5,
    name: "5 Minutes"
  },
  {
    time: 15,
    name: "15 Minutes"
  },
  {
    time: 30,
    name: "30 Minutes"
  },
  {
    time: 45,
    name: "45 Minutes"
  },
  {
    time: 60,
    name: "1 Hour"
  },
  {
    time: 120,
    name: "2 Hours"
  },
  {
    time: 240,
    name: "4 Hours"
  },
  {
    time: 360,
    name: "6 Hours"
  },
  {
    time: 480,
    name: "8 Hours"
  },
  {
    time: 720,
    name: "12 Hours"
  },
  {
    time: 1440,
    name: "1 Day"
  },
  {
    time: 2880,
    name: "2 Days"
  },
  {
    time: 4320,
    name: "3 Days"
  },
  {
    time: 7200,
    name: "5 Days"
  },
  {
    time: 10080,
    name: "7 Days"
  },
  {
    time: 14400,
    name: "10 Days"
  },
  {
    time: 21600,
    name: "15 Days"
  },
  {
    time: 43200,
    name: "30 Days"
  },
  {
    time: 129600,
    name: "3 Months"
  },
  {
    time: 259200,
    name: "6 Months"
  }
];

export let Product = {
  ContentFuzeFULL: 1,
  ConnectPro: 2,
  ShowroomPro: 3,
  ComparePro: 4,
  ServicePro: 5,
  SpanishContentFuze: 6,
  VDPTool: 7,
  AutoWebSupport: 9,
  ReputationPro: 10,
  CuratorPro: 11,
  CuratorProPlus: 12,
  ReviewBuilderPro: 13,
  WebsiteContentPage: 14,
  FuzeCast: 15,
  ManagedServices: 16,
  ProfileFuze: 17,
  AlertMiner: 18,
  OneToOne: 19,
  Pando: 20,
  GeoAlert: 21,
  AutoAssistant: 23
};

export let ProductStatus = {
  Unknown: 0,
  Setup: 1,
  Live: 2,
  Cancelled: 3,
  OnHold: 4
};

export let AccountProductFeature = {
  AlertMinerFull: 1024,
  ExperienceManager: 16384,
  CXM: 262144,
  ILM: 5767168,
  Messaging: 4718592,
  Calendar: 65536,
  Processes: 5242880,
  CallTracking: 8388608,
  AutoAssistantSales: 2097152,
  AutoAssistantService: 33554432,
  AutoAssistantLeads: 34078720,
  GeoAlert: 2621440,
  Desking: 16777216,
  Analytics: 131072,
  SLM: 1572864,
  SurveyPro: 34603008,
  VideoMessaging: 35127296,
  PAL: 36175872
};

export let CalendarEventType = {
  PhoneCall: 8,
  Appointment: 9,
  Touchpoint: 10
};

export let CalendarAppointmentTypeId = {
  ShowroomVisit: 0,
  DeliveryVisit: 1,
  PhoneCall: 2,
  General: 3
};

export let CalendarAppointmentStatus = {
  Scheduled: 0,
  Rescheduled: 1,
  Confirmed: 2,
  NoShow: 3,
  Completed: 4,
  ConfirmationSent: 5,
  Cancelled: 6
};

export let LoadingStatus = {
  Loading: 1,
  Loaded: 2
};

export const RULE_TYPES = {
  RuleTerminator: "ruleTerminator",
  TaskCompletion: "taskCompletion",
  Trigger: "trigger"
};

export const RuleActionErrors = {
  NotInRuleGroup: "not_in_rule_group",
  ReusedAction: "reused_action",
  ShowroomDisabled: "showroom_disabled",
  DeliveryDisabled: "delivery_disabled",
  DisabledAsTrigger: "disabled_as_trigger",
  DisabledAsTaskComplete: "disabled_as_task_complete",
  DisabledAsTerminator: "disabled_as_terminator"
};

export let ActivityFeedCategory = {
  All: 0,
  O2O: 1,
  Email: 2,
  Phone: 3,
  SMS: 4,
  Website: 5,
  OnTheLot: 6,
  SLM: 7,
  OnlineReview: 8,
  GeoAlert: 9,
  AutoAssist: 10,
  Notes: 11,
  Pando: 12,
  Print: 13,
  Appointments: 14,
  VAuto: 15,
  ADFLead: 16,
  Contact: 17,
  CustomerHistory: 18,
  Dealsheet: 19,
  Delivery: 20,
  DeskIt: 21,
  GarageUpdate: 22,
  GenericActivity: 23,
  IM: 24,
  Lead: 25,
  CRM: 26,
  Opportunity: 27,
  Reassignment: 28,
  RecommendedAction: 29,
  Sale: 30,
  Saved: 31,
  Service: 32,
  Showroom: 33,
  ViewProfile: 34,
  VinScan: 35,
  Unwind: 36,
  LeadTouchpoint: 37,
  Appointment_Showroom: 38,
  Appointment_Delivery: 39,
  Appointment_Phone: 40,
  Appointment_General: 41,
  DMSPush: 42,
  FinancePush: 43,
  LeadTrade: 44,
  InventoryMatch: 45,
  Desking: 46,
  HappyBirthday: 47,
  Survey: 48,
  VideoMessaging: 88,
  MobileScanning: 49,
  PAL: 50
};

export const SpecialActivityTypeIds = {
  OneToOnePurl: 22,
  Showroom: [43],
  Delivery: [44],
  VideoMessaging: 88
};

export const SpecialActionTypeIds = {
  NotSet_Unknown: 0,
  CompletedCall_LeftMessage: 1,
  CompletedCall_NoAnswer: 2,
  CompletedCall_CallBack: 3,
  PandoProcess_Started: 4,
  PandoProcess_Claimed: 5,
  PandoProcess_AutoClaimed: 6,
  PandoProcess_Assigned: 7,
  PandoProcess_Reassigned: 8,
  PandoProcess_Declined: 9,
  PandoProcess_Canceled: 10,
  PandoProcess_AutoCanceled: 11,
  PandoProcess_Completed: 12,
  EmailReply_CustomerReplied: 13,
  ADFLead_CRMLeadForward: 14,
  EmailReply_Completed: 17,
  EmailReply_Closed: 20,
  Email_EmailSent: 22,
  Email_EmailReply: 23,
  Email_CustomerUnsubscribed: 24,
  Email_EmailViewed: 25,
  Email_EmailLinkClicked: 26,
  Sale_PendingSale: 27,
  Sale_NewSale: 28,
  VinScan_VINScancompleted: 29,
  Service_CustomerInService: 30,
  PrintedOffer_PrintedOffer: 31,
  PandoWorkflow_SLMCustomer: 32,
  DealSheet_MarkedasSold: 33,
  DealSheet_Watched: 34,
  DealSheet_Unwatched: 35,
  DealSheet_MarkedasNotOwned: 36,
  DealSheet_MarkedasPaidOff: 37,
  DealSheet_ViewedDealSheet: 38,
  DealSheet_ViewedCarFaxReport: 39,
  DealSheet_ViewedCarProofReport: 40,
  DealSheetAccess_ManualReassign: 42,
  DealSheetAccess_ManualGrantAccess: 43,
  DealSheetAccess_ManualRevokeAccess: 44,
  CustomerHistory_MarkedDoNotCall: 45,
  CustomerHistory_UnmarkedDoNotCall: 46,
  CustomerHistory_MarkedDoNotEmail: 47,
  CustomerHistory_UnmarkedDoNotEmail: 48,
  CustomerHistory_MarkedDonotMail: 49,
  CustomerHistory_UnmarkedDoNotMail: 50,
  Appointment_ServiceApptScheduled: 51,
  CompletedCall_Miscellaneous: 52,
  CompletedCall_Interested: 53,
  PostedNote_UpgradeProposal: 54,
  PostedNote_Miscellaneous: 55,
  CompletedCall_NoLongerOwns: 56,
  ManualPushtoCRM_Unknown: 57,
  CompletedCall_ScheduleAppt: 58,
  ScheduleAppt_SalesApptScheduled: 60,
  CompletedCall_NotInterested: 61,
  PostedNote_NotInterested: 62,
  PostedNote_NoLongerOwns: 63,
  CompletedCall_HelloWorld: 64,
  CompletedCall_Sold: 65,
  CompletedCall_BadPhoneNumber: 66,
  CompletedCall_DoNotCall: 67,
  PostedNote_AppointmentSet: 68,
  PostedNote_OnetoOneOfferPrinted: 69,
  PostedNote_Sold: 70,
  PostedNote_SpoketoClient: 71,
  PostedNote_TestDriveDone: 72,
  OneToOneMail_MailSentO2O: 73,
  OneToOneMail_EMailSentO2O: 74,
  OneToOneMail_EmailClickO2O: 75,
  OneToOneMail_EmailOpenO2O: 76,
  OneToOneMail_pUrlViewedO2O: 77,
  OneToOnePurl_ReadytoReplaceCTAClicked: 78,
  OneToOnePurl_GetYourOfferCTAClicked: 79,
  OneToOnePurl_PrintyourOfferIconClicked: 80,
  OneToOnePurl_DealerWebsiteLinkClickedHeader: 81,
  OneToOnePurl_ReadytoUpgradeCTAClicked: 82,
  OneToOnePurl_pUrlVisitedfromTypein: 83,
  OneToOnePurl_pUrlVisitedfromEmail: 84,
  OneToOnePurl_DealerWebsiteLinkClickedAuthorizedDealerSection: 85,
  OneToOnePurl_PrintYourOfferCTAClicked: 86,
  OneToOnePurl_O2OpUrlViewed: 87,
  OneToOnePurl_O2OpURLLead: 88,
  Website_CustomerNowEngaged: 89,
  Website_WebsiteLeadSubmission: 90,
  OnlineReview_ServiceReview: 91,
  OnlineReview_SalesReview: 92,
  Sale_ValidatedSale: 93,
  DealSheet_ViewedCarProof: 94,
  Website_WebsiteFormSubmission: 95,
  OneToOnePurl_DealerServiceLinkClickedFooter: 96,
  OneToOnePurl_DealerWebsiteLinkClickedFooter: 97,
  OneToOnePurl_pUrlVisitedfromFacebook: 98,
  Website_FacebookClicktoDealerWebsite: 99,
  CompletedCall_SpokeToClient: 100,
  PostedNote_SpokeToClient: 101,
  ScheduleCall_ScheduledCall: 102,
  CompletedCall_Unknown: 103,
  ManualPushtoCRM_PushedtoCRM: 104,
  DealSheetAccess_AutomaticReassign: 105,
  DealSheetAccess_AutomaticGrantAccess: 106,
  PhoneCallComplete_AppointmentSet: 107,
  PhoneCallComplete_CallBack: 108,
  PhoneCallComplete_DoNotCall: 109,
  PhoneCallComplete_LeftMessage: 110,
  PhoneCallComplete_NoAnswer: 111,
  PhoneCallComplete_NotInterested: 112,
  PhoneCallComplete_Sold: 113,
  PhoneCallComplete_SpokeToClient: 114,
  PhoneCallComplete_BadPhoneNumber: 115,
  PhoneCallComplete_Interested: 116,
  PhoneCallComplete_NoLongerOwns: 117,
  PhoneCallComplete_Miscellaneous: 118,
  AppointmentComplete_DidNotShow: 119,
  AppointmentComplete_Showedclosed: 120,
  AppointmentComplete_Showedopen: 121,
  AppointmentComplete_ShowedSold: 122,
  ExpirePhoneCall_Expired: 123,
  ExpireAppointment_Expired: 124,
  PhoneCallReschedule_Rescheduled: 125,
  AppointmentReschedule_Rescheduled: 126,
  PhoneCallReassign_Reassigned: 127,
  AppointmentReassign_Reassigned: 128,
  PhoneCallCancel_Canceled: 129,
  AppointmentCancel_Canceled: 130,
  OpportunitySearch_OpportunitySearch: 131,
  AutoAssistant_AutoAssistantHotLead: 132,
  GeoAlert_GeoAlertActive: 133,
  SavedSearch_OpportunitySearch: 134,
  Website_WebsiteVDP: 135,
  Website_WebsiteSRP: 136,
  IntelligentMarketing_IMpUrlViewed: 137,
  IntelligentMarketing_IMpURLLead: 138,
  Contact_AddContact: 139,
  CompletedCall_VehiclePaidOff: 140,
  PhoneCallComplete_VehiclePaidOff: 141,
  Sale_Retail: 142,
  Sale_Lease: 143,
  Sale_Cash: 144,
  Sale_Balloon: 145,
  Service_ServiceClosed: 146,
  ViewProfile_ViewSnapshot: 147,
  ViewProfile_ViewVehicle: 148,
  Sale_RetailSeed: 149,
  Sale_LeaseSeed: 150,
  ShowroomVisit_ShowroomVisitstarted: 151,
  ShowroomVisit_ShowroomVisitrestarted: 152,
  ShowroomVisit_ShowroomVisitcompleted: 153,
  ShowroomVisit_ShowroomVisitdemostarted: 154,
  ShowroomVisit_ShowroomVisitdemocompleted: 155,
  ShowroomVisit_ShowroomVisittradeappraisalstarted: 156,
  ShowroomVisit_ShowroomVisittradeappraisalcompleted: 157,
  ShowroomVisit_ShowroomVisitwriteupstarted: 158,
  ShowroomVisit_ShowroomVisitwriteupcompleted: 159,
  ShowroomVisit_ShowroomVisitmanagerturnoverstarted: 160,
  ShowroomVisit_ShowroomVisitmanagerturnovercompleted: 161,
  ShowroomVisit_ShowroomVisitDemoCanceled: 442,
  ShowroomVisit_ShowroomVisitTradeAppraisalCanceled: 443,
  ShowroomVisit_ShowroomVisitWriteupCanceled: 444,
  ShowroomVisit_ShowroomVisitManagerTurnoverCanceled: 445,
  Delivery_Deliverystarted: 162,
  Delivery_Deliveryrestarted: 163,
  Delivery_Deliverycompleted: 164,
  Delivery_Deliveryfinanceandinsurancestarted: 165,
  Delivery_Deliveryfinanceandinsurancecompleted: 166,
  Delivery_Deliveryaccessoriesintrostarted: 167,
  Delivery_Deliveryaccessoriesintrocompleted: 168,
  Delivery_Deliveryserviceintrostarted: 169,
  Delivery_Deliveryserviceintrocompleted: 170,
  Delivery_Deliverytechintrostarted: 171,
  Delivery_Deliverytechintrocompleted: 172,
  Delivery_DeliveryFinanceAndInsuranceCanceled: 446,
  Delivery_DeliveryAccessoriesIntroCanceled: 447,
  Delivery_DeliveryServiceIntroCanceled: 448,
  Delivery_DeliveryTechIntroCanceled: 449,
  SMS_IncomingServiceText: 179,
  SMS_IncomingSalesText: 180,
  SMS_OutgoingServiceText: 181,
  SMS_OutgoingSalesText: 182,
  Email_IncomingEmail: 183,
  Email_OutgoingEmail: 184,
  LeadManagement_LeadCreated: 185,
  Contact_ContactCreated: 186,
  CompletedCall_LogInboundCall: 187,
  CompletedCall_LogOutboundCall: 188,
  ScheduleCall_SchedulePhoneCall: 189,
  ScheduleCall_SchedulePhoneCallComplete: 190,
  ScheduleCall_ReschedulePhoneCall: 191,
  ScheduleAppt_ScheduleAppointment: 192,
  ScheduleAppt_CancelAppointment: 193,
  LogANote_LogNote: 194,
  Email_EmailOpened: 195,
  Desking_PushedDeal: 196,
  ScheduleCall_CancelPhoneCall: 197,
  ViewProfile_ViewProfile: 198,
  ShowroomVisit_ShowroomVisitcompletedSold: 199,
  CompletedCall_LogCallInboundAlertMiner: 200,
  CompletedCall_LogCallOutboundAlertMiner: 201,
  LeadManagement_Active: 202,
  LeadManagement_Bad: 203,
  LeadManagement_Duplicate: 204,
  LeadManagement_Lost: 205,
  LeadManagement_SoldPending: 206,
  LeadManagement_SoldDelivered: 207,
  LeadManagement_ReactivateLostLead: 208,
  LeadManagement_Completed: 209,
  ShowroomVisit_ShowroomVisitautoclose: 210,
  LeadManagement_LeadAutoClose: 211,
  RecommendedAction_Call: 212,
  RecommendedAction_Email: 213,
  Reassignment_TaskReassignment: 214,
  Reassignment_ContactReassignment: 215,
  Reassignment_LeadReassignment: 216,
  Reassignment_LeadAssignment: 423,
  Email_BulkEmail: 217,
  OpportunityExport_Print: 218,
  OpportunityExport_Export: 219,
  Email_AutomatedEmail: 220,
  Email_PandoProcessEmail: 221,
  SMS_SalesTextOptOut: 222,
  SMS_SalesTextOptIn: 223,
  SMS_ServiceTextOptOut: 224,
  SMS_ServiceTextOptIn: 225,
  DealsheetIntegrations_vAutoAppraisal: 226,
  ViewProfile_ViewService: 227,
  ViewProfile_ViewActiveSalesLeads: 228,
  ViewProfile_ViewActiveServiceLeads: 229,
  ViewProfile_ViewLeadHistory: 230,
  ViewProfile_ViewMessages: 231,
  ViewProfile_ViewEngagement: 232,
  ViewProfile_ViewResolution: 233,
  ViewProfile_ViewChangelog: 234,
  ViewProfile_ViewActivity: 235,
  ViewProfile_ViewGarage: 236,
  LeadsExported_LeadsExported: 237,
  DealsheetIntegrations_SubmitSmartVincent: 238,
  DealsheetIntegrations_SubmitOasis: 239,
  Contact_ContactUpdate: 240,
  Contact_ContactCompanyUpdate: 241,
  Contact_ContactHouseholdUpdate: 242,
  GarageUpdate_TradeValue: 243,
  GarageUpdate_Payoff: 244,
  GarageUpdate_Mileage: 245,
  GarageUpdate_Price: 246,
  GarageUpdate_NoLongerOwns: 247,
  GarageUpdate_Reopen: 248,
  GarageUpdate_FinancialWizard: 249,
  AutoAssistant_ActionRequired: 252,
  AutoAssistant_LeadAtRisk: 253,
  GenericActivity_OpportunitySearch: 254,
  GenericActivity_CustomerSearch: 255,
  CallTracking_RecordedCall: 256,
  GenericActivity_GenericActivity: 257,
  Email_EmailUnsubscribe: 258,
  Email_EmailBounce: 259,
  Email_EmailDropped: 260,
  GarageUpdate_VehiclePurchasedByDealer: 261,
  GarageUpdate_MarkedAsSold: 262,
  Contact_ContactMergeStarting: 263,
  Contact_ContactMergeCompleted: 264,
  Contact_ContactMergeFailed: 265,
  Unwind_Unwind: 266,
  Workflow_TasksuppressedduetocontactInformation: 268,
  Email_AutoResponder: 269,
  StudioServiceMarketing_EmailSent: 270,
  StudioServiceMarketing_MailSent: 271,
  StudioServiceMarketing_EmailClick: 272,
  Appointment_ConfirmationSent: 281,
  Appointment_ConfirmationReceived: 282,
  Desking_DeskStarted: 283,
  Desking_DealStarted: 284,
  Desking_CoBuyerAdded: 285,
  DMSPush_SentToDMS: 287,
  ActiveLeadStages_WaitingOnVehicleCompleted: 303,
  ActiveLeadStages_TradeInCompleted: 301,
  ActiveLeadStages_ShoppingCompleted: 299,
  ActiveLeadStages_ContactAttemptedCompleted: 295,
  ActiveLeadStages_ContactMadeCompleted: 297,
  ActiveLeadStages_WaitingOnVehicleStarted: 302,
  ActiveLeadStages_TradeInStarted: 300,
  ActiveLeadStages_ShoppingStarted: 298,
  ActiveLeadStages_ContactAttemptedStarted: 294,
  ActiveLeadStages_ContactMadeStarted: 296,
  Appointment_Showroom_Scheduled: 177,
  Appointment_Showroom_Rescheduled: 173,
  Appointment_Showroom_NoShow: 174,
  Appointment_Showroom_Shown: 307,
  Appointment_Showroom_Cancelled: 308,
  Appointment_Showroom_Confirmation_Sent: 328,
  Appointment_Showroom_Confirmation_Received: 329,
  Appointment_Delivery_Scheduled: 178,
  Appointment_Delivery_Rescheduled: 175,
  Appointment_Delivery_NoShow: 176,
  Appointment_Delivery_Shown: 311,
  Appointment_Delivery_Cancelled: 321,
  Appointment_Delivery_Confirmation_Sent: 326,
  Appointment_Delivery_Confirmation_Received: 327,
  Appointment_Phone_Scheduled: 316,
  Appointment_Phone_Rescheduled: 317,
  Appointment_Phone_NoShow: 304,
  Appointment_Phone_Shown: 305,
  Appointment_Phone_Cancelled: 318,
  Appointment_Phone_Confirmation_Sent: 322,
  Appointment_Phone_Confirmation_Received: 323,
  Appointment_General_Scheduled: 319,
  Appointment_General_Rescheduled: 306,
  Appointment_General_NoShow: 310,
  Appointment_General_Shown: 309,
  Appointment_General_Cancelled: 320,
  Appointment_General_Confirmation_Sent: 324,
  Appointment_General_Confirmation_Received: 325,
  LeadManagement_LeadTypeUpdateInternet: 312,
  LeadManagement_LeadTypeUpdateShowroom: 313,
  LeadManagement_LeadTypeUpdatePhone: 314,
  LeadManagement_LeadSourceUpdate: 315,
  AutoAssistant_PhoneNumberDiscovered: 330,
  AutoAssistant_ActionsRequired: 331,
  AutoAssistant_LeadsAtRisk: 332,
  AutoAssistant_HotLead: 333,
  AutoAssistant_LeadToReview: 334,
  AutoAssistant_FurtherAction: 335,
  AutoAssistant_Satisfied: 336,
  AutoAssistant_Disqualified: 337,
  AutoAssistant_NoFurtherAction: 338,
  AutoAssistant_PreparingLead: 339,
  AutoAssistant_Messaging: 340,
  AutoAssistant_Excluded: 341,
  AutoAssistant_Unworkable: 342,
  AutoAssistant_LeadStopped: 343,
  AutoAssistant_ClientStopped: 344,
  AutoAssistant_ConversicaStopped: 345,
  AutoAssistant_Sent_To_AutoAssistant: 347,
  Email_InboundConversicaEmail: 348,
  Email_OutboundConversicaEmail: 349,
  PreScreen_Completed: 350,
  CreditReport_Completed: 351,
  MobileScanning_DriversLicense: 352,
  OFAC_Completed: 355,
  Showroom_Visit_Note: 372,
  ManagerAction_OnDemandWorkflowTriggered: 373,
  CallTracking_Inbound: 382,
  InventoryMatch_Completed: 385,
  AutoAssistant_Failed_send_to_AutoAssistant: 386,
  LeadTrade_Added: 384,
  LeadTrade_Updated: 388,
  LeadTrade_Deleted: 389,
  PostedNote_VehiclePaidOff: 390,
  Unwind_Lead: 391,
  HappyBirthday: 394,
  Survey_Response_Received: 395,
  Negative_Survey_Rating_Received: 396,
  Positive_Survey_Rating_Received: 397,
  Neutral_Survey_Rating_Received: 398,
  Survey_Sent: 399,
  Survey_Failed_To_Send: 400,
  CustomerHistory_BadEmail_Invalid: 401,
  CustomerHistory_BadEmail_UserSpecified: 402,
  CustomerHistory_BadEmail_DeliveryBounce: 403,
  PDFEmailBulk: 422,
  VideoSent: 425,
  VideoViewed: 426,
  VideoFormSubmission: 427,
  VideoLinkClicked: 428,
  DealsheetIntegrations_VinCueAppraisal: 429,
  DealsheetIntegrations_VinCueAppraisalUpdate: 454,
  PAL_PersonalAccessClicked: 434,
  PAL_CustomerLinkViewed: 435,
  PAL_CustomerLink_VehicleLiked: 436,
  PAL_PersonalAccessLink_InboundMessage: 437,
  PAL_CustomerLink_RequestVehicleInfo: 438,
  PAL_CustomerLink_TradeQuoteRequested: 439,
  PAL_CustomerLink_ServiceAppointmentRequested: 440
};

export const ActionTypeGroups = {
  CompletedCall: [
    66,
    3,
    67,
    64,
    53,
    1,
    200,
    201,
    187,
    188,
    52,
    2,
    56,
    61,
    58,
    65,
    100,
    103,
    140
  ],
  PhoneCallComplete: [
    107,
    115,
    108,
    109,
    116,
    110,
    118,
    111,
    117,
    112,
    113,
    26,
    141
  ],
  EmailReplyGroup: [20, 17, 13, 258, 259, 260],
  OneToOneMail: [75, 76, 74, 73, 77],
  OneToOnePurl: [96, 85, 97, 81, 79, 88, 87, 86, 80, 84, 98, 83, 78, 82],
  Rescheduled: [175, 173, 125, 191],
  EngagedText: [179, 180],
  EngagedEmail: [23, 24, 25, 26, 195, 183],
  EngagedReview: [91, 92],
  AppointmentSet: [64, 68, 107],
  ActivityTypeContact: [139, 241, 186, 242, 264, 265, 263, 240],
  ActivityTypeEmail: [
    220,
    217,
    24,
    259,
    260,
    26,
    195,
    23,
    22,
    258,
    25,
    183,
    184,
    221
  ],
  ActivityTypeGarageUpdate: [249, 262, 245, 247, 244, 246, 248, 243, 261],
  ActivityTypeGenericActivity: [255, 257, 254],
  DoNotCall: [67, 109],
  BadPhoneNumber: [66, 115],
  CallBack: [3, 108],
  LeftMessage: [1, 110], // Not in use
  Miscellaneous: [52, 118, 55], // Not in use
  NoAnswer: [2, 111], // Not in use
  NoLongerOwns: [117, 63], // Not in use
  NoLongerOwnsGarage: 247,
  NotInterested: [61, 112, 62], // Not in use
  PostedNote: [68, 55, 63, 62, 69, 70, 71, 101, 72, 54],
  Purl: [77, 84, 98, 83],
  Sold: [65, 70, 113], // Not in use
  SpokeToClient: [100, 101, 114, 71], // Not in use
  Unknown: [103, 0], // Not in use
  VehiclePaidOff: [140, 141] // Not in use
};

export const SpecialLeadStatusIds = {
  Active: 1,
  Lost: 2,
  Bad: 3,
  Duplicate: 4,
  SoldPending: 6,
  SoldDelivered: 5
};

export const LeadDisplayStatus = {
  Unclaimed: -2,
  New: -1,
  Active: 1,
  Lost: 2,
  Bad: 3,
  Duplicate: 4,
  SoldDelivered: 5,
  SoldPending: 6
};

export const SpecialTouchpointResultIds = {
  SoldDelivery: 1,
  ScheduleDeliveryToday: 2,
  ScheduleDeliveryFuture: 3,
  SoldPending: 4,
  OnOrder: 5,
  Unsold: 6,
  SoldDelivered: 7,
  DeliverySoldPending: 8,
  DeliveryOnOrder: 9,
  RequiresVehicles: [
    1, //SpecialTouchpointResultIds.SoldDelivery,
    4, //SpecialTouchpointResultIds.SoldPending,
    7, // SpecialTouchpointResultIds.SoldDelivered
    8 //SpecialTouchpointResultIds.DeliverySoldPending
  ]
};

export const ImportLeadDispositions = {
  Lost_ImportLeadId: 9,
  Lost_AutoClose: 23,
  Duplicate_ImportLeadId: 15,
  Unsold_AutoClose: 7
};
export const TouchpointResults = {
  SoldDelivery: 1,
  ScheduleToday: 2,
  ScheduleFuture: 3,
  SoldPending: 4,
  OnOrder: 5,
  Unsold: 6,
  SoldDelivered: 7,
  DeliverySoldPending: 8,
  DeliveryOnOrder: 9,
  ShowroomUnwind: 10,
  DeliveryUnwind: 11
};

export const StringStartRegex = /^/;
export const StringEndRegex = /$/;

export let EpochTicks = 621355968000000000;

export const DEFAULT_SHOWROOM_DURATION = 4 * 60;

export const SortDirections = [
  {
    id: 0,
    name: "Ascending"
  },
  {
    id: 1,
    name: "Descending"
  }
];

export const OtherSortDirections = [
  {
    id: 0,
    name: "Oldest"
  },
  {
    id: 1,
    name: "Newest"
  }
];

export const SortDirectionsByName = arrayToObj(SortDirections, "name");
export const OtherSortDirectionsByName = arrayToObj(
  OtherSortDirections,
  "name"
);

/// TODO: actionId to be updated when api is ready
export const ShowroomInShowroomSubtypes = [
  {
    actionId: 0,
    name: "New Customers"
  },
  {
    actionId: 1,
    name: "Previously Sold Customers"
  },
  {
    actionId: 2,
    name: "Be Back"
  }
];

export const ShowroomAppointmentSubtypes = [
  {
    status: 0,
    name: "Scheduled"
  },
  {
    status: 1,
    name: "Re-Scheduled"
  },
  {
    status: 2,
    name: "Confirmed"
  },
  {
    status: 3,
    name: "No Show"
  },
  {
    status: 4,
    name: "Completed"
  }
];

export const AdditionalLeadsSubTypes = [
  {
    status: 0,
    name: "Internet"
  },
  {
    status: 1,
    name: "Sold Internet"
  },
  {
    status: 2,
    name: "Phone"
  },
  {
    status: 3,
    name: "Sold Phone"
  },
  {
    status: 4,
    name: "Other"
  },
  {
    status: 5,
    name: "Sold Other"
  }
];

export const DeliveryAppointmentSubtypes = [
  {
    status: 0,
    actionId: 178,
    name: "Scheduled"
  },
  {
    status: 1,
    actionId: 175,
    name: "Re-Scheduled"
  },
  {
    status: 2,
    actionId: 326,
    name: "Confirmed"
  },
  {
    status: 3,
    actionId: 176,
    name: "No Show"
  },
  {
    status: 4,
    actionId: 311,
    name: "Completed"
  }
];

export const TouchpointAppointmentsSortOptions = [
  {
    Name: "Appointment Start Time",
    Value: "starttime"
  }
];

export const ModalTypes = {
  SendText: "SendText",
  Deskit: "Deskit",
  SendEmail: "SendEmail",
  EmailHistory: "EmailHistory",
  RawAdfLead: "RawAdfLeadModal",
  PrintModal: "PrintModal",
  LogNote: "LogNote",
  LogCall: "LogCall",
  NewProcess: "NewProcess"
  // OpportunitiesDashboardLayout: "OpportunitiesDashboardLayout"
};

export const RelatedItemType = {
  Contact: 0,
  Inventory: 1,
  Lead: 2,
  CRMImport: 3,
  EmailConversation: 4,
  ParentLead: 5,
  DuplicateLead: 6
};

export const MaxSMSLength = 1600;
export const MaxNoteLength = 1900;

export const LeadTypeIds = {
  ShowroomSales: 1,
  InternetSales: 2,
  PhoneSales: 3,
  Other: 4,
  InternetService: 5,
  PhoneService: 6,
  InternetParts: 7,
  PhoneParts: 8
};
export const ExcludeLeadTypeIds = {
  InternetSales: 2,
  Other: 4,
  InternetService: 5,
  PhoneService: 6,
  InternetParts: 7,
  PhoneParts: 8
};
export const DealTypes = {
  Retail: 0,
  Lease: 1
};
export const DMSDealTypes = {
  Cash: 0,
  Lease: 1,
  Retail: 2,
  CXM: 3
};
export const SaleTypeNames = [
  { name: "Balloon", symbol: "B" },
  { name: "Retail", symbol: "P" },
  { name: "Lease", symbol: "L" },
  { name: "Cash", symbol: "C" }
];

export const SaleTypes = {
  Lease: 1,
  Retail: 2,
  Balloon: 3,
  Cash: 4,
  OnePayLease: 6,
  Wholesale: 7,
  InComplete: 8,
  Conquest: 9,
  Converted: 10
};
export const DealType = {
  None: 0,
  Retail: 1,
  Lease: 2,
  Cash: 3
};

export const SelectFinancialFieldIds = {
  RetailPayment: 0,
  RetailAmountFinanced: 1,
  RetailAPR: 2,
  BalloonPayment: 3,
  BalloonAmountFinanced: 4,
  BalloonDeferred: 5
};

export const ReportDiscrepancyFields = {
  TradeInValue: "Trade-in Value",
  PayoffAmount: "Payoff Amount",
  ReplacementVehicle: "Replacement Vehicle",
  BalloonRate: "Balloon Rate",
  BalloonFactoryRebate: "Balloon Factory Rebate",
  BalloonDealerRebate: "Balloon Dealer Rebate",
  RetailRate: "Retail Rate",
  RetailFactoryRebate: "Retail Factory Rebate",
  RetailDealerRebate: "Retail Dealer Rebate",
  LeaseRate: "Lease Rate",
  LeaseFactoryRebate: "Lease Factory Rebate",
  LeaseDealerRebate: "Lease Dealer Rebate",
  Other: "Other"
};

export const DiscrepancyReportFieldTypeEnums = {
  None: 0,
  TradeInValue: 1,
  PayoffAmount: 2,
  ReplacementVehicle: 3,
  BalloonRate: 4,
  BalloonFactoryRebate: 5,
  BalloonDealerRebate: 6,
  RetailRate: 7,
  RetailFactoryRebate: 8,
  RetailDealerRebate: 9,
  LeaseRate: 10,
  LeaseFactoryRebate: 11,
  LeaseDealerRebate: 12,
  Other: 13
};

export const NoteType = {
  OutboundEmail: 12,
  InboundEmail: 13,
  ADFComment: 18,
  Unwind: 19,
  OemLeadComment: 23
};

export const GenericUnknownError =
  "Something went wrong... Please refresh the page and try again.";

export const UnusedKeySymbol = Symbol("__EMPTY_KEY__");

export const ActivityGroups = {
  CallsInbound: 1,
  CallsOutbound: 2,
  CallsScheduled: 3,
  EmailsSent: 4,
  EmailsRead: 5,
  EmailsReplied: 6,
  AppointmentsSet: 7,
  AppointmentsShown: 8,
  AppointmentsSold: 9,
  SMSActivity: 10,
  OffersActivity: 11,
  SLMActivity: 12,
  EmailActivity: 13,
  PhoneActivity: 14,
  ReviewsActivity: 15,
  WebVisitsActivity: 16,
  GeoAlertActivity: 17,
  AutoAssistantActivity: 18,
  ContactKeyActivity: 19,
  AllActivity: 20,
  OnTheLot: 21,
  Desking: 22,
  Delivery: 23,
  NoteActivity: 25,
  Viewed: 26,
  SLMCompleted: 27,
  OpportunitiesCustomerMessages: 28,
  OpportunitiesService: 29,
  OpportunitiesOneToOne: 30,
  OpportunitiesWeb: 31,
  OpportunitiesReviewPro: 32,
  OpportunitiesGeoAlert: 33,
  Worked: 34,
  OpportunitiesRecentlyAssigned: 35,
  TextSMS: 41,
  Exported: 42,
  OutboundUserActivity: 43,
  BulkEmail: 54,
  TextOut: 71,
  PreScreen: 81,
  CreditReport: 82
};

export const RecentActivityGroups = [
  { name: "AutoAssistant", id: ActivityGroups.AutoAssistantActivity },
  { name: "Incoming Text/SMS", id: ActivityGroups.TextSMS },
  { name: "Email Reply", id: ActivityGroups.EmailsReplied },
  { name: "GeoAlert", id: ActivityGroups.OpportunitiesGeoAlert },
  {
    name: "One to One/Intelligent Marketing",
    id: ActivityGroups.OpportunitiesOneToOne
  },
  { name: "Review Pro", id: ActivityGroups.OpportunitiesReviewPro },
  { name: "Service", id: ActivityGroups.OpportunitiesService },
  { name: "Web", id: ActivityGroups.OpportunitiesWeb },
  { name: "Exported", id: ActivityGroups.Exported },
  {
    name: "Incoming Call",
    id: ActivityGroups.CallsInbound
  },
  {
    name: "Outbound User Activity",
    id: ActivityGroups.OutboundUserActivity
  },
  {
    name: "Note Activity",
    id: ActivityGroups.NoteActivity
  },
  {
    name: "Bulk Email",
    id: ActivityGroups.BulkEmail
  },
  {
    name: "Credit Report",
    id: ActivityGroups.CreditReport
  },
  {
    name: "Pre-Screen",
    id: ActivityGroups.PreScreen
  }
];

export const RecentActivityTypes = [
  { name: "SMS", id: ActivityGroups.SMSActivity, icon: "sms" },
  { name: "Offers", id: ActivityGroups.OffersActivity, icon: "dealsheet" },
  { name: "SLM", id: ActivityGroups.SLMActivity, icon: "product-SLM" },
  { name: "Email", id: ActivityGroups.EmailActivity, icon: "email" },
  { name: "Phone", id: ActivityGroups.PhoneActivity, icon: "phone" },
  { name: "Reviews", id: ActivityGroups.ReviewsActivity, icon: "reviews" },
  { name: "WebVisits", id: ActivityGroups.WebVisitsActivity, icon: "website" },
  { name: "GeoAlert", id: ActivityGroups.GeoAlertActivity, icon: "geoalert" },
  {
    name: "AutoAssistant",
    id: ActivityGroups.AutoAssistantActivity,
    icon: "auto-assistant"
  }
];

export const EventBusEvents = {
  LeadStatusRefresh: "LeadStatusRefresh",
  CheckCrmLeads: "CheckCrmLeads",
  RefreshVOIList: "RefreshVOIList",
  RefreshTradeInsList: "RefreshTradeInsList",
  LeadsDashboardPaginationUpdated: "LeadsDashboardPaginationUpdated",
  UpdateLocalLeadsDashboardPagination: "UpdateLocalLeadsDashboardPagination",
  LoadLeadsDashboardSavedSearch: "LoadLeadsDashboardSavedSearch",
  LoadContactSearchSavedSearch: "LoadContactSearchSavedSearch",
  UpdateLeadsDashboardAdvanceFilters: "UpdateLeadsDashboardAdvanceFilters",
  UpdateLeadsDashboardSearch: "UpdateLeadsDashboardSearch",
  AddVoiToLead: "AddVoiToLead",
  EmitCustomSnotifyError: "EmitCustomSnotifyError",
  RefreshCalendarEvents: "RefreshCalendarEvents",
  UpdateTouchpointItems: "UpdateTouchpointItems",
  ReloadOppSearchDashboard: "reloadOppSearchDashboard",
  UpdateReplacementVehicleOption: "updateReplacementVehicleOptisnapson",
  ReloadUnmatchedDMSSalesRecords: "ReloadUnmatchedDMSSalesRecords",
  ReloadReplacementDetails: "ReloadReplacementDetails",
  ChangeLeadsSubTab: "ChangeLeadsSubTab",
  HelperFunctionSnotifyNotification: "HelperFunctionSnotifyNotification",
  ExportLeadsDashboardResults: "ExportLeadsDashboardResults",
  ExportCallTrackingDashboardResults: "ExportCallTrackingDashboardResults",
  UpdateCallTrackingDashboardFilters: "UpdateCallTrackingDashboardFilters",
  UpdateCallTrackingDashboardFilterByName:
    "UpdateCallTrackingDashboardFilterByName",
  CallTrackingDashboardPaginationUpdated:
    "CallTrackingDashboardPaginationUpdated",
  UpdateLocalCallTrackingDashboardPagination:
    "UpdateLocalCallTrackingDashboardPagination",
  ResetMarkAsSold: "ResetMarkAsSold",
  ResetPurchasedByDealer: "ResetPurchasedByDealer",
  ResetNoLongerOwns: "ResetNoLongerOwns",
  ResetOpportunitySortFilter: "ResetOpportunitySortFilter",
  ResetOpportunitySearchFilters: "ResetOpportunitySearchFilters",
  EmitNoPermissionToViewContact: "EmitNoPermissionToViewContact",
  AddNewLead: "AddNewLead",
  AddLeadVOI: "AddLeadVOI",
  AddLeadTrade: "AddLeadTrade",
  ReloadLeadMetaData: "ReloadLeadMetaData",
  ReloadLeadTab: "ReloadLeadTab",
  ReloadActivityTab: "ReloadActivityTab",
  ResetDashboardFilters: "ResetDashboardFilters",
  RefreshDashboardWidgets: "RefreshDashboardWidgets",
  UpdateHasActiveVisit: "UpdateHasActiveVisit",
  ReloadCustomerDashboard: "ReloadCustomerDashboard",
  LoadTableauView: "LoadTableauView",
  UpdateShownStatusInSlideout: "UpdateShownStatusInSlideout",
  RefreshWishlistGroups: "RefreshWishlistGroups",
  RefreshWishlistVehicles: "RefreshWishlistVehicles",
  HandleCopyWorkflow: "HandleCopyWorkflow",
  TriggerCustomerSearch: "TriggerCustomerSearch",
  SaveHouseholdMemberInfo: "saveHouseholdMemberInfo",
  SelectExistingContact: "SelectExistingContact",
  ClearHouseHoldMemberInfo: "ClearHouseHoldMemberInfo",
  UserProfileLogout: "UserProfileLogout",
  InventorySearchPaginationUpdated: "InventorySearchPaginationUpdated",
  InventorySortOptionsUpdated: "InventorySortOptionsUpdated",
  RefreshSavedSearches: "RefreshSavedSearches",
  RefreshInventorySavedSearches: "RefreshInventorySavedSearches",
  ReloadTaskList: "ReloadTaskList",
  InventorySearchResultsGridLayoutUpdated:
    "InventorySearchResultsGridLayoutUpdated",
  InventoryLeadsLayoutUpdated: "InventoryLeadsLayoutUpdated",
  VideosSelected: "VideosSelected",
  UpdateContactVOIList: "UpdateContactVOIList",
  CancelTouchpointStepStatus: "CancelTouchpointStepStatus",
  RefreshCustomerTagCounts: "RefreshCustomerTagCounts"
};
export const EngagementTypeCategories = {
  Total: 1,
  Viewed: 2,
  NoFollowUp: 3
};

export const RoleSystemNames = {
  SalesPerson: "dealer.sales.sales_person",
  SalesManager: "dealer.sales.sales_manager",
  BDCAgent: "dealer.sales.bdc_agent",
  BDCManager: "dealer.sales.bdc_manager",
  ServiceAdvisor: "dealer.service.service_advisor",
  ServiceManager: "dealer.service.service_manager",
  FIManager: "dealer.sales.f_and_i_manager",
  DealerAdmin: "dealer.office.dealer_admin",
  GeneralManager: "dealer.office.general_manager",
  UsedCarManager: "dealer.sales.used_car_sales_manager",
  MarketingManager: "dealer.office.marketing_manager",
  GeneralSalesManager: "dealer.sales.general_sales_manager",
  PartsManager: "dealer.parts.parts_manager"
};

export const AssignmentRoleGroupsSystemNames = {
  sales: [
    RoleSystemNames.SalesPerson,
    RoleSystemNames.SalesManager,
    RoleSystemNames.BDCAgent,
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ],
  salesManager: [
    RoleSystemNames.SalesManager,
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ],
  serviceAdvisor: [
    RoleSystemNames.ServiceAdvisor,
    RoleSystemNames.ServiceManager,
    RoleSystemNames.PartsManager
  ],
  bdcAgent: [
    RoleSystemNames.BDCAgent,
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ],
  fiManager: [
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ],
  SalesDashboardFilterRoles: [
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.DealerPrincipal,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.ServiceManager,
    RoleSystemNames.SalesManager,
    RoleSystemNames.MarketingManager, //portfolio manager?
    RoleSystemNames.GeneralSalesManager
  ],
  InventoryFindBuyerFilterRoles: [
    RoleSystemNames.SalesPerson,
    RoleSystemNames.SalesManager,
    RoleSystemNames.BDCAgent,
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ]
};

export const CustomerType = {
  Unknown: 0,
  Individual: 1,
  Commercial: 2,
  Fleet: 3
};

export let ActivityRulesRoleType = {
  SalesAssociate: 1,
  SalesAssociate2: 2,
  BDAgent: 3,
  SalesManager: 4,
  ServiceAdvisor: 5,
  FAndIManager: 6
};
export const CustomerTypes = [
  { id: 0, name: "Unknown" },
  { id: 1, name: "Individual" },
  { id: 2, name: "Commercial" },
  { id: 3, name: "Fleet" }
];

export const PhoneType = {
  Unknown: 0,
  HomePhone: 1,
  WorkPhone: 2,
  CellPhone: 3
};

export const CustomerTypesByName = arrayToObj(CustomerTypes, "name");
export const CustomerTypesById = arrayToObj(CustomerTypes, "id");

export const TouchpointActionsPanelState = {
  Default: 0,
  ViewVehicles: 1,
  EndVisit: 2
};

export const DisabledProducts = {
  CuratorPro: 11,
  ProfileFuze: 17
};
export const DisabledFeatures = {
  Articles: 8,
  Comparisons: 4,
  Gamification: 128,
  Messages: 16,
  Pando: 32,
  PandoLite: 512,
  ProfileFuze: 64,
  Reports: 256,
  Reviews: 2,
  HR: 8192,
  Tagging: 32768,
  ServiceLaneTechnology: 2048,
  OnlineOffer: 4096
};

export const OpportunityLayoutHiddenFields = [
  { displayName: "Contact ID", id: "contactId" },
  { displayName: "EntityId", id: "entityId" },
  { displayName: "DMS Deal ID", id: "dmsDealId" },
  { displayName: "Customer ID", id: "customerId" },
  { displayName: "First Name", id: "firstName" },
  { displayName: "Last Name", id: "lastName" },
  { displayName: "Business Name", id: "businessName" },
  { displayName: "Account Platform ID", id: "accountPlatformId" },
  {
    id: "isAlert",
    displayName: "Is Alert"
  },
  {
    id: "isFlexAlert",

    displayName: "Is Flex"
  },
  {
    id: "isInMarket",
    displayName: "Is In Makret"
  },
  {
    id: "isInMarketEngaged",
    displayName: "Is Engaged"
  },
  {
    id: "isOverAllowance",
    displayName: "Is Mileage Alert"
  },
  {
    id: "isWarrantyAlert",
    displayName: "Is Warranty Alert"
  },
  {
    id: "isContractEnd",
    displayName: "Is Contract End"
  },
  {
    id: "isService",
    displayName: "Is Service"
  },
  {
    id: "isAppointment",
    displayName: "Is Appointment"
  },
  {
    id: "payload",
    displayName: "Payload"
  },
  {
    id: "dealSheetUrl",
    displayName: "URL"
  }
];
export const SalesLayoutHiddenFields = [
  { displayName: "Contact ID", id: "contactId" },
  { displayName: "EntityId", id: "entityId" },
  { displayName: "DMS Deal ID", id: "dmsDealId" },
  { displayName: "Customer ID", id: "customerId" },
  { displayName: "First Name", id: "firstName" },
  { displayName: "Last Name", id: "lastName" },
  { displayName: "Business Name", id: "businessName" },
  { displayName: "Account Platform ID", id: "accountPlatformId" },
  {
    id: "isAlert",
    displayName: "Is Alert"
  },
  {
    id: "isFlexAlert",

    displayName: "Is Flex"
  },
  {
    id: "isInMarket",
    displayName: "Is In Makret"
  },
  {
    id: "isInMarketEngaged",
    displayName: "Is Engaged"
  },
  {
    id: "isOverAllowance",
    displayName: "Is Mileage Alert"
  },
  {
    id: "isWarrantyAlert",
    displayName: "Is Warranty Alert"
  },
  {
    id: "isContractEnd",
    displayName: "Is Contract End"
  },
  {
    id: "isService",
    displayName: "Is Service"
  },
  {
    id: "isAppointment",
    displayName: "Is Appointment"
  },
  {
    id: "payload",
    displayName: "Payload"
  },
  {
    id: "dealSheetUrl",
    displayName: "URL"
  },
  {
    id: "taskDescription",
    displayName: "Description"
  },
  {
    id: "lastCustomerActivityDate",
    displayName: "Customer Activity Date"
  },
  {
    id: "lastUserActivityDate",
    displayName: "User Activity Date"
  }
];

export const OpportunitiesWidgetType = {
  NotSet: 0,
  OpportunitiesByAlert: 1,
  TaggedOpportunities: 2,
  CampaignSearches: 3,
  Service: 4,
  CustomerMessages: 5,
  Web: 6,
  RecentlyAssigned: 7,
  TopRetailOpportunities: 8,
  TopLeaseOpportunities: 9,
  OneToOne: 10,
  ReviewPro: 11,
  GeoAlert: 12,
  OpportunityDashboardSearchResults: 13,
  LeadsLog: 14
};

export const SalesDashboardWidgetType = {
  NotSet: 26,
  TaskList: 27
};

export const CampaignSearchSegments = {
  Total: 0,
  Worked: 1,
  NotWorked: 2,
  Viewed: 3
};

export const OpportunityDashboardWidgets = [
  {
    Name: "Opportunities By Alert",
    Type: OpportunitiesWidgetType.OpportunitiesByAlert,
    LayoutKey:
      UserSettingKeys.OPPORTUNITIES_DASHBOARD_OPPORTUNITIES_BY_ALERT_LAYOUT,
    Filters: {
      ActivityGroupIds: [ActivityGroups.Viewed, ActivityGroups.Worked]
    }
  }
];

export const PriorityOpportunitiesWidgets = [
  {
    Name: "Service",
    Type: OpportunitiesWidgetType.Service,
    LayoutKey: UserSettingKeys.PRIORITY_OPPORTUNITIES_SERVICE_LAYOUT,
    Icon:
      "https://assets.autoalert.com/img/autoalert-icons/icon-engagement-service-vanilla.svg",
    Filters: {
      ActivityGroupId: ActivityGroups.OpportunitiesService,
      ActivityGroupTimeframeDays: 30
    }
  },
  {
    Name: "Customer Messages",
    Type: OpportunitiesWidgetType.CustomerMessages,
    LayoutKey: UserSettingKeys.PRIORITY_OPPORTUNITIES_CUSTOMER_MESSAGES_LAYOUT,
    Icon:
      "https://assets.autoalert.com/img/autoalert-icons/icon-product-messages-vanilla.svg",
    Filters: {
      ActivityGroupId: ActivityGroups.OpportunitiesCustomerMessages,
      ActivityGroupTimeframeDays: 30
    }
  },
  {
    Name: "Web",
    Type: OpportunitiesWidgetType.Web,
    LayoutKey: UserSettingKeys.PRIORITY_OPPORTUNITIES_WEB_LAYOUT,
    Icon:
      "https://assets.autoalert.com/img/autoalert-icons/icon-website-vanilla.svg",
    Filters: {
      ActivityGroupId: ActivityGroups.OpportunitiesWeb,
      ActivityGroupTimeframeDays: 30
    }
  },
  {
    Name: "Recently Assigned",
    Type: OpportunitiesWidgetType.RecentlyAssigned,
    LayoutKey: UserSettingKeys.PRIORITY_OPPORTUNITIES_RECENTLY_ASSIGNED_LAYOUT,
    Filters: {
      ActivityGroupId: ActivityGroups.OpportunitiesRecentlyAssigned,
      ActivityGroupTimeframeDays: 30
    }
  },
  {
    Name: "Top Retail Opportunities",
    Type: OpportunitiesWidgetType.TopRetailOpportunities,
    LayoutKey:
      UserSettingKeys.PRIORITY_OPPORTUNITIES_TOP_RETAIL_OPPORTUNITIES_LAYOUT,
    Filters: {
      SaleType: ["Retail", "Retail (U)"],
      IsOpportunity: true,
      EntityType: [1, 2]
    }
  },
  {
    Name: "Top Lease Opportunities",
    Type: OpportunitiesWidgetType.TopLeaseOpportunities,
    LayoutKey:
      UserSettingKeys.PRIORITY_OPPORTUNITIES_TOP_LEASE_OPPORTUNITIES_LAYOUT,
    Filters: {
      SaleType: ["Lease", "Lease (U)"],
      IsOpportunity: true,
      EntityType: [1, 2]
    }
  },
  {
    Name: "One-to-One / Intelligent Marketing",
    Type: OpportunitiesWidgetType.OneToOne,
    LayoutKey: UserSettingKeys.PRIORITY_OPPORTUNITIES_ONE_TO_ONE_LAYOUT,
    Icon:
      "https://assets.autoalert.com/img/autoalert-icons/icon-engagement-printed-one-to-one-vanilla.svg",
    Filters: {
      ActivityGroupId: ActivityGroups.OpportunitiesOneToOne,
      ActivityGroupTimeframeDays: 30
    }
  },
  {
    Name: "Review Pro",
    Type: OpportunitiesWidgetType.ReviewPro,
    LayoutKey: UserSettingKeys.PRIORITY_OPPORTUNITIES_REVIEW_PRO_LAYOUT,
    Icon:
      "https://assets.autoalert.com/img/autoalert-icons/icon-product-review-pro-vanilla.svg",
    Filters: {
      ActivityGroupId: ActivityGroups.OpportunitiesReviewPro,
      ActivityGroupTimeframeDays: 30
    }
  },
  {
    Name: "Geo Alert",
    Type: OpportunitiesWidgetType.GeoAlert,
    LayoutKey: UserSettingKeys.PRIORITY_OPPORTUNITIES_GEO_ALERT_LAYOUT,
    Icon:
      "https://assets.autoalert.com/img/autoalert-icons/icon-geoalert-vanilla.svg",
    Filters: {
      ActivityGroupId: ActivityGroups.OpportunitiesGeoAlert,
      ActivityGroupTimeframeDays: 30
    }
  }
];
export const ServiceExperienceWidgetType = {
  NotSet: 20,
  ServiceMonitor: 21,
  HaveNotServiced: 22,
  DueForService: 23,
  NeedsWarranty: 24,
  ServiceAppointments: 25
};

export const ServiceExperienceWidgets = [
  {
    Name: "Service Monitor",
    Type: ServiceExperienceWidgetType.ServiceMonitor,
    LayoutKey: UserSettingKeys.SERVICE_EXPERIENCE_SERVICE_MONITOR_LAYOUT,
    // Icon:
    //   "https://assets.autoalert.com/img/autoalert-icons/icon-engagement-service-vanilla.svg",
    Filters: {}
  },
  {
    Name: "Have Not Serviced",
    Type: ServiceExperienceWidgetType.HaveNotServiced,
    LayoutKey: UserSettingKeys.SERVICE_EXPERIENCE_HAVE_NOT_SERVICED_LAYOUT,
    // Icon:
    //   "https://assets.autoalert.com/img/autoalert-icons/icon-product-messages-vanilla.svg",
    Filters: {}
  },
  {
    Name: "Due for Service",
    Type: ServiceExperienceWidgetType.DueForService,
    LayoutKey: UserSettingKeys.SERVICE_EXPERIENCE_DUE_FOR_SERVICE_LAYOUT,
    // Icon:
    //   "https://assets.autoalert.com/img/autoalert-icons/icon-website-vanilla.svg",
    Filters: {}
  },
  {
    Name: "Needs Warranty",
    Type: ServiceExperienceWidgetType.NeedsWarranty,
    LayoutKey: UserSettingKeys.SERVICE_EXPERIENCE_NEEDS_WARRANTY_LAYOUT,
    Filters: {}
  },
  {
    Name: "Service Appointments",
    Type: ServiceExperienceWidgetType.ServiceAppointments,
    LayoutKey: UserSettingKeys.SERVICE_EXPERIENCE_SERVICE_APPOINTMENTS_LAYOUT,
    Filters: {}
  }
];

export const OpportunityDashboardSearchResultsWidget = [
  {
    Name: "Opportunities Search Dashboard",
    Type: OpportunitiesWidgetType.OpportunityDashboardSearchResults,
    LayoutKey: UserSettingKeys.OPPORTUNITY_DASHBOARD_SEARCH_RESULTS
  }
];
export const SalesDashboardWidget = [
  {
    Name: "Task List",
    Type: SalesDashboardWidgetType.TaskList,
    LayoutKey: UserSettingKeys.SALES_DASHBOARD_TASK_LIST_LAYOUT
  }
];

export const DataType = {
  NotSet: "notset",
  DateTime: "datetime",
  String: "string",
  Number: "int",
  Currency: "currency",
  Alerts: "alerts",
  HotStatus: "hotStatus",
  OpportunityScore: "score",
  Bool: "bool",
  Numeric: "numeric",
  URL: "url",
  ActionButton: "actionButton",
  Minutes: "minutes"
};

export const OpportunityTags = {
  CreditConvert: 319,
  VinRecall: 2404,
  FordLincolnRecalls: 10005,
  DigitalRetailingActivity: 5009
};
export const OpportunitiesDashboardMaximumLayoutColumnNumber = 12;
export const OpportunitiesDashboardMinimumLayoutColumnNumber = 3;

export const OpportunityFieldCategories = [
  {
    DisplayName: "Calculation",
    CategoryName: "calculation"
  },
  {
    DisplayName: "Customer",
    CategoryName: "customer"
  },
  {
    DisplayName: "Customer Assignments",
    CategoryName: "customerAssignment"
  },
  {
    DisplayName: "Deal Info",
    CategoryName: "dealInfo"
  },
  {
    DisplayName: "Mileage Estimates",
    CategoryName: "mileageEstimates"
  },
  {
    DisplayName: "Recent RO",
    CategoryName: "recentRO"
  },
  {
    DisplayName: "Vehicle",
    CategoryName: "vehicle"
  },
  {
    DisplayName: "Warranty",
    CategoryName: "warranty"
  },
  {
    DisplayName: "Recalls",
    CategoryName: "recall"
  },
  {
    DisplayName: "Upcoming Appointments",
    CategoryName: "appointment"
  },
  {
    DisplayName: "Recent Activity",
    CategoryName: "recentActivity"
  },
  {
    DisplayName: "One to One",
    CategoryName: "oneToOne"
  },
  {
    DisplayName: "Service Monitor",
    CategoryName: "serviceMonitor"
  }
];
export const SalesDashboardFieldCategories = [
  {
    DisplayName: "Customer",
    CategoryName: "customer"
  },
  {
    DisplayName: "Customer Assignments",
    CategoryName: "customerAssignment"
  },

  {
    DisplayName: "Vehicle",
    CategoryName: "vehicle"
  },
  {
    DisplayName: "Upcoming Appointments",
    CategoryName: "appointment"
  },
  {
    DisplayName: "Recent Activity",
    CategoryName: "recentActivity"
  },
  {
    DisplayName: "Task",
    CategoryName: "task"
  }
];

export const SavedAdvancedOpportunitySearchVisibilityTypes = {
  Personal: 0,
  Shared: 1
};

export const SavedAdvancedOpportunitySearchActivationTypes = {
  Disabled: 0,
  Manual: 1,
  Automated: 2
};
export const AllowedDateFormats = [
  "M/D/YYYY",
  "MM/D/YYYY",
  "M/DD/YYYY",
  "MM/DD/YYYY",
  "M/D/YY",
  "MM/D/YY",
  "M/DD/YY",
  "MM/DD/YY"
];

export const EntityType = {
  Native: 1,
  Converted: 2,
  Conquest: 3
};

export const RuleCategoryIds = [
  { Id: 1, Name: "Sales" },
  { Id: 2, Name: "Service" },
  { Id: 3, Name: "Inventory Acquisition" },
  { Id: 4, Name: "Conquest" }
];

export const DAILY_CAMPAIGN_SEARCH_RUN_MAX = 13;

export const CAMPAIGN_SEARCH_MAX_TASKS_PER_RUN = 500;

export const MAX_EMAIL_LENGTH = 500000;

export const SmsOptInStatus = {
  Unknown: 1,
  ContactOptIn: 2,
  ContactOptOut: 3,
  UserOptOut: 4
};
export const ProfileLeadsTabs = {
  ActiveSales: 1,
  ActiveService: 2,
  LeadsHistory: 3,
  UserOptOut: 4
};

export const TradeSource = {
  Blackbook: 2,
  Galves: 5
};

export const DMSPushResponseMethod = {
  None: 0,
  AM: 1,
  CXM: 2
};

export const genericEntityId = "00000000-0000-0000-0000-000000000000";
export const WorkflowManagerCurrencyFilterIds = [51, 52, 53, 54, 55, 56];
export const maxEmailAttachmentSize = 25;
export const maxSMSAttachmentSize = 5;
export const acceptedEmailAttachments = [
  ".png",
  ".jpg",
  ".jpeg",
  ".doc",
  ".docx",
  ".pdf",
  ".heif",
  ".heic",
  ".mp4",
  ".mov",
  ".mpeg",
  ".mpg",
  ".mp3",
  ".xls",
  ".xlsx"
];
export const acceptedSMSAttachments = [
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".tiff",
  ".tif",
  ".l24",
  ".ogg",
  ".3gp",
  ".ac3",
  ".mp4",
  ".mov",
  ".mpeg",
  ".mpg",
  ".mp3",
  ".webm",
  ".h261",
  ".m4v",
  ".h264"
];
export const dangerousEmailAttachments = [
  ".exe",
  ".jar",
  ".bat",
  ".psc1",
  ".vb",
  ".vbs",
  ".msi",
  ".cmd",
  ".reg",
  ".wsf"
];

export const FormPacketStatus = {
  Draft: 0,
  Active: 1,
  Archived: 2
};

export const FormType = {
  NotSet: 0,
  CustomQuote: 1
};

export let PageSize = {
  US_Letter: "us_letter",
  US_Legal: "us_legal"
};

export let PageSizeDimensions = {
  [PageSize.US_Letter]: {
    Width: "8.5in",
    Height: "11in"
  },
  [PageSize.US_Legal]: {
    Width: "8.5in",
    Height: "14in"
  }
};

export const CallTrackingTypeCountsEnum = {
  Inbound: 0,
  Outbound: 1,
  All: 2
};

export const CallTrackingStatusCountsEnum = {
  Unmatched: 0,
  Matched: 1,
  All: 2
};

export const CallTrackingDateCountsEnum = {
  Today: 1,
  Yesterday: 2,
  Last7: 3,
  Last30: 4,
  LastMonth: 5
};

export const DateRangeEnums = {
  Custom: 0,
  Today: 1,
  Yesterday: 2,
  Last7: 3,
  Last14: 4,
  Last30: 5,
  Last60: 6,
  Last90: 7,
  Last180: 8,
  Last365: 9
};

export const DateRange = [
  { Name: "Custom", Id: DateRangeEnums.Custom, days: 1 },
  { Name: "Today", Id: DateRangeEnums.Today, days: 1 },
  { Name: "Yesterday", Id: DateRangeEnums.Yesterday, days: 2 },
  { Name: "Last 7 Days", Id: DateRangeEnums.Last7, days: 8 },
  { Name: "Last 14 Days", Id: DateRangeEnums.Last14, days: 15 },
  { Name: "Last 30 Days", Id: DateRangeEnums.Last30, days: 31 },
  { Name: "Last 60 Days", Id: DateRangeEnums.Last60, days: 61 },
  { Name: "Last 90 Days", Id: DateRangeEnums.Last90, days: 91 },
  { Name: "Last 180 Days", Id: DateRangeEnums.Last180, days: 181 },
  { Name: "Last 365 Days", Id: DateRangeEnums.Last365, days: 366 }
];
export const ShownStatusType = {
  NotSet: 0,
  Shown: 1,
  NoShow: 2
};

export let ConfirmationModalType = {
  AddCallTrackingProspect: 1,
  AssignUnmatchedCall: 2,
  LogCallAfterMatchingSlideout: 3,
  CustomerDashboard: 4,
  LeadVehicles: 5,
  PushToPbsModal: 6,
  MatchDMSSale: 7,
  ContactMerge: 8,
  Unwind: 9,
  ManageWorkflows: 10,
  MarkAppointments: 11,
  ReassignAssignedTasks: 12,
  DeleteLeadWishlist: 13,
  DeskIt: 14,
  CompleteEndedToucpointStep: 15,
  ActionsPanelVehicles: 16,
  CancelTouchpointVisitStepStatus: 17
};

export let PushToCrmActivityCodeResult = {
  PushToCRMSuccess: 110,
  PushToCRMFailPermission: 111,
  PushToCRMFailDelivery: 113,
  StandardActivity_Success: 120,
  GeneralException: 131
};

export let IncomeType = {
  Employer: 1,
  ChildSupport: 2,
  Alimony: 3
};

export let EmploymentStatus = {
  Employed: 1,
  Unemployed: 2
};

export let HousingType = {
  Owns: 1,
  Rents: 2
};
export let BankAccountType = {
  Checking: 1,
  Savings: 2,
  MoneyMarket: 3,
  Retirement: 4
};

export const Months = [
  {
    id: 1,
    name: "January"
  },
  {
    id: 2,
    name: "February"
  },
  {
    id: 3,
    name: "March"
  },
  {
    id: 4,
    name: "April"
  },
  {
    id: 5,
    name: "May"
  },
  {
    id: 6,
    name: "June"
  },
  {
    id: 7,
    name: "July"
  },
  {
    id: 8,
    name: "August"
  },
  {
    id: 9,
    name: "September"
  },
  {
    id: 10,
    name: "October"
  },
  {
    id: 11,
    name: "November"
  },
  {
    id: 12,
    name: "December"
  }
];

export const Suffixes = [
  {
    id: "Jr.",
    name: "Jr."
  },
  {
    id: "Sr.",
    name: "Sr."
  },
  {
    id: "II",
    name: "II"
  },
  {
    id: "III",
    name: "III"
  },
  {
    id: "IV",
    name: "IV"
  }
];

export const PreferredMeansOfContact = {
  Any: 0,
  Mail: 1,
  Text: 2,
  Email: 3,
  Phone: 4
};

export const PreferredTimeOfContact = {
  Any: 0,
  Morning: 1,
  Afternoon: 2,
  Evening: 3
};

export const PreferredMeansOfContactList = [
  {
    id: 0,
    name: "Any"
  },
  {
    id: 1,
    name: "Mail"
  },
  {
    id: 2,
    name: "Text"
  },
  {
    id: 3,
    name: "Email"
  },
  {
    id: 4,
    name: "Phone"
  }
];

export const PreferredTimeOfContactList = [
  {
    id: 0,
    name: "Any"
  },
  {
    id: 1,
    name: "Morning"
  },
  {
    id: 2,
    name: "Afternoon"
  },
  {
    id: 3,
    name: "Evening"
  }
];
export let DMSEmployeeTypes = {
  SalesPerson1: 0,
  SalesPerson2: 1,
  SalesManager: 2,
  FandIManager: 3
};
export let DMSValidationTypes = {
  Deal: 1,
  Buyer: 2,
  Cobuyer: 3,
  All: 0
};
export let DMSTypes = {
  NA: 0,
  CDK: 1,
  RCI: 2,
  Serti: 23,
  DealerTrack: 9,
  PBS: 16,
  Automate: 5,
  Dealerbuilt: 38,
  AutoVance: 39,
  CDK180: 18,
  Tekion: 40
};
export let FinanceTypes = {
  NA: 0,
  RouteOne: 1,
  SevenHundredCredit: 2,
  SevenHundredCreditPrescreen: 3,
  DealerTrackFinance: 4
};
export let DMSPushBaseRequestTypes = {
  NA: 0,
  RouteOne: 1,
  DealerTrackFinance: 2,
  DealerTrack: 3,
  CDK: 4,
  RCI: 5,
  PBS: 6,
  Serti: 7,
  Automate: 8,
  Dealerbuilt: 9,
  AutoVance: 10,
  CDK180: 11
};

export const FormTokens = {
  EmptyToken: 209,
  DriversLicenseNumber: 214,
  DriversLicenseIssue: 215,
  DriversLicenseExpiration: 216,
  CheckboxToken: 220,
  RadioButtonToken: 221,
  DriversLicenseFront: 222,
  DriversLicenseBack: 223
};

export const DashboardWidgetType = {
  Calls: "calls",
  Engaged: "engaged",
  Emails: "emails",
  Appointments: "appointments",
  LeadActivity: "leadActivity",
  SLMActivity: "slmActivity",
  RecentActivities: "recentActivities",
  ShowroomActivity: "showroomActivity",
  ShowroomAppointments: "showroomAppointments",
  DeliveryActivity: "deliveryActivity",
  DeliveryAppointments: "deliveryAppointments",
  Workplan: "workplan",
  TaskList: "taskList",
  Video: "video",
  Tags: "tags"
};

export const DashboardWidgets = {
  Calls: {
    Id: DashboardWidgetType.Calls,
    Name: "Calls"
  },
  Engaged: {
    Id: DashboardWidgetType.Engaged,
    Name: "Engaged"
  },
  Emails: {
    Id: DashboardWidgetType.Emails,
    Name: "Emails"
  },
  Video: {
    Id: DashboardWidgetType.Video,
    Name: "Video Messaging"
  },
  Appointments: {
    Id: DashboardWidgetType.Appointments,
    Name: "Appointments"
  },
  LeadActivity: {
    Id: DashboardWidgetType.LeadActivity,
    Name: "Lead Activity",
    Features: [AccountProductFeature.ILM]
  },
  SLMActivity: {
    Id: DashboardWidgetType.SLMActivity,
    Name: "SLM Activity"
  },
  RecentActivities: {
    Id: DashboardWidgetType.RecentActivities,
    Name: "Recent Activities"
  },
  ShowroomActvity: {
    Id: DashboardWidgetType.ShowroomActivity,
    Name: "Showroom Activity",
    Features: [AccountProductFeature.ExperienceManager]
  },
  ShowroomAppointments: {
    Id: DashboardWidgetType.ShowroomAppointments,
    Name: "Showroom Appointments",
    Features: [AccountProductFeature.ExperienceManager]
  },
  DeliveryActivity: {
    Id: DashboardWidgetType.DeliveryActivity,
    Name: "Delivery Activity",
    Features: [AccountProductFeature.ExperienceManager]
  },
  DeliveryAppointments: {
    Id: DashboardWidgetType.DeliveryAppointments,
    Name: "Delivery Appointments",
    Features: [AccountProductFeature.ExperienceManager]
  },
  Workplan: {
    Id: DashboardWidgetType.Workplan,
    Name: "Workplan"
  },
  TaskList: {
    Id: DashboardWidgetType.TaskList,
    Name: "Task List"
  },
  Tags: {
    Id: DashboardWidgetType.Tags,
    Name: "Tagged Customers"
  }
};

export const WidgetType = {
  InShowroom: 0,
  Appointments: 1,
  Delivery: 2,
  AdditionalLeads: 3
};

export const DefaultDashboardLayout = [
  {
    rank: 0,
    widgets: [
      DashboardWidgets.Calls,
      DashboardWidgets.Engaged,
      DashboardWidgets.Emails
    ]
  },
  {
    rank: 1,
    widgets: [DashboardWidgets.Appointments]
  },
  {
    rank: 2,
    widgets: [DashboardWidgets.Video]
  },
  {
    rank: 3,
    widgets: [DashboardWidgets.LeadActivity]
  },
  {
    rank: 4,
    widgets: [DashboardWidgets.SLMActivity]
  },
  {
    rank: 5,
    widgets: [DashboardWidgets.RecentActivities]
  },
  {
    rank: 6,
    widgets: [
      DashboardWidgets.ShowroomActvity,
      DashboardWidgets.ShowroomAppointments
    ]
  },
  {
    rank: 7,
    widgets: [
      DashboardWidgets.DeliveryActivity,
      DashboardWidgets.DeliveryAppointments
    ]
  },
  {
    rank: 8,
    widgets: [DashboardWidgets.Workplan]
  },
  {
    rank: 9,
    widgets: [DashboardWidgets.TaskList]
  },
  {
    rank: 10,
    widgets: [DashboardWidgets.Tags]
  }
];
export const CreditRequestTypes = {
  PreScreen: 1,
  HardPull: 2,
  Ofac: 3
};

export const CreditRequestStatusTypes = {
  Pending: 1,
  Complete: 2
};
export const CreditBureauType = {
  Experian: 0,
  TransUnion: 1,
  Equifax: 2
};

export const TableauDefaultCategory = {
  id: 0,
  name: "Misc.",
  bgColor: "bg-potato",
  color: "#7A4119"
};

export const TableauCategoryMapByName = {
  Other: TableauDefaultCategory,
  CXMActivity: {
    id: 1,
    name: "CXM Activity",
    bgColor: "bg-ocean",
    color: "#34699E"
  },
  LeadReporting: {
    id: 2,
    name: "Lead Reporting",
    bgColor: "bg-avocado",
    color: "#257F31"
  },
  Revenue: {
    id: 3,
    name: "Revenue",
    bgColor: "bg-ocean-deep",
    color: "#172751"
  },
  Inventory: {
    id: 4,
    name: "Inventory",
    bgColor: "bg-apple",
    color: "#ED2124"
  },
  Campaign: { id: 5, name: "Campaign", bgColor: "bg-pond", color: "#03C0E6" },
  PandoProcess: {
    id: 6,
    name: "Pando Process",
    bgColor: "bg-sapota",
    color: "#c98600"
  },
  FixedOperations: {
    id: 7,
    name: "Fixed Operations",
    bgColor: "bg-orange",
    color: "#FF6100"
  }
};

export const TableauCategoryDetails = arrayToObj(
  Object.values(TableauCategoryMapByName),
  "id"
);

export const UserCustomNotificationType = {
  CUSTOMER_PROFILE_UPDATE: "CUSTOMER_PROFILE_UPDATE",
  USER_PROFILE_LOGOUT: "USER_PROFILE_LOGOUT",
  CUSTOMER_PROFILE_DESK_COBUYER_ADDED: "CUSTOMER_PROFILE_DESK_COBUYER_ADDED",
  GLOBAL_FRAME_HEADER_INFO_UPDATE: "GLOBAL_FRAME_HEADER_INFO_UPDATE"
};

export const WorkflowCategory = {
  BrowseAll: -1,
  NoCategory: 0,
  Sales: 10,
  Office: 20,
  Service: 30,
  Parts: 40,
  BodyCollisionCenter: 50,
  HR: 60,
  Misc: 70,
  FI: 80,
  Management: 90,
  Integration: 100,
  WorkflowTriggered: 140
};

export const WorkflowSubcategory = {
  NotSet: 0,
  OpportunitySearch: 110,
  SelfRegistration: 120,
  SLM: 130,
  Wishlist: 150
};

export const SpecialTemplateCategory = {
  RepAndReview: 5
};

export const CampaignStatus = {
  New: 1,
  Pending: 2,
  NotVerified: 3,
  Available: 4,
  Disabled: 98,
  Deleted: 99
};

export const EndVisitReasonIdLeadStatus = {
  DidNotAgreeTerms: 2,
  TradeValueDisputed: 3,
  UnableObtainFinancing: 5,
  VehicleSelectionUnavailable: 6
};

export const EndVisitReasonLostDefaults = {
  BadCredit: 1,
  NoAgreementReached: 8,
  VehicleNotAvailable: 24
};

export const OFACStatusEnum = {
  None: 1,
  Successful: 2,
  Negative: 3
};

export const AppraisalProvider = {
  vAuto: 1,
  VinCue: 2
};

export const VideoTypes = [
  {
    Id: 1,
    Name: "Sales"
  },
  {
    Id: 2,
    Name: "Service"
  }
];

export const VideoType = {
  Sales: 1,
  Service: 2
};

export const VideoAccessLevels = {
  Personal: 1,
  Dealer: 2,
  Both: 3
};

export const VideoCategory = {
  Sales: 1,
  Service: 2
};

export const VideoGroups = {
  Sent: 0,
  Viewed: 1,
  Clicks: 2,
  Submissions: 3,
  Appointments: 4,
  Responses: 5
};

export const TagTypes = {
  Dealer: 1,
  OEMProgramsVariable: 2,
  OEMProgramsFixed: 3,
  AITags: 1000
};



// WEBPACK FOOTER //
// ./src/lib/utilities/enums.js